import { Inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { LoaderService } from '../ng2-loader/ng2-loader';
import { getDateObj } from './date.service';
import { DatePipe } from '@angular/common';
import { NphiesRequestMessage_log } from '../hospitalSetup/fhir-test/fhir-test.service';
import { EntityService } from '../blocks/entity.service';
import { DOCUMENT } from '@angular/common';



export interface communicationResonCode {
    coding?: codingInterface[];
}

export interface supportingInfoMajorInterface {
    sequence?: number;
    category?: supportingInfoCategoryInterface;
    valueQuantity?: supportingInfoValueQuantityInterface
}
export interface supportingInfoCategoryInterface {
    coding?: codingInterface[];
}

export interface supportingInfoValueQuantityInterface {
    value?: any
    system?: any
    code?: any
}

export interface bodySiteArr {
    coding?: CodingArr[]
}

export interface coverageClassObj {
    type: coverageType;
    value: string
    name: string
}


export interface coverageType {
    coding?: codingInterface[]
}
export interface codingInterface {
    system?: any
    code?: any
    display?: any
}

export interface diagnosisCodeableConcept {
    coding?: codingInterface[]
}

export interface diagnosisType {
    coding?: codingInterface[]
}

export interface diagnosesList {
    sequence?: number;
    diagnosisCodeableConcept?: diagnosisCodeableConcept
    onAdmission?: any
    type?: diagnosisType[]
    extension?: extensionItem[]
}

export interface CodingArr {
    system?: any
    code?: any
    display?: any

}
export interface productOrServiceCodingArr {
    coding?: CodingArr[]
    text?: string
}

export interface unitPriceAndNet {
    value?: any;
    currency?: any
}

export interface quantity {
    value?: any;
}

export interface ItemMajorInterFace {
    extension: any[],
    sequence: number;
    careTeamSequence: any[],
    diagnosisSequence: any[],
    informationSequence: any[],
    productOrService: productOrServiceCodingArr,
    servicedDate: any,
    quantity: quantity
    unitPrice: unitPriceAndNet
    net: unitPriceAndNet
    bodySite: bodySiteArr
    factor: any
}

export interface MainStructureVital {
    sequence: number;
    category: categoryInterFace
    valueQuantity: valueQuantityInterFace
    code?: categoryInterFace
}

export interface ChiefComplaint {
    sequence: number;
    category: categoryInterFace
    code: categoryInterFace
}
export interface Attachment {
    sequence: number;
    category: categoryInterFace
    timingDate:Date
    valueAttachment: ValueAttachment
}

export interface ValueAttachment {
    contentType: string;
    title: string
    data: string
    language:string
    size:number
    creation:Date
}

export interface categoryInterFace {
    coding?: codingInterface[]
    text?: string
}
export interface valueQuantityInterFace {
    value: any;
    system: any;
    code: any;
}

//-------------------------------
export interface valueMoneyInterFace {
    value: any;
    currency: any;
}
export interface valueIdentifierInterFace {
    system: any;
    value: any;
}

export interface ExtensionTaxInterFace {
    url: any;
    valueMoney: valueMoneyInterFace;
}
export interface ExtensionPatientShareInterFace {
    url: any;
    valueMoney: valueMoneyInterFace;
}

export interface ExtensionPatientInvoiceInterFace {
    url: any;
    valueIdentifier: valueIdentifierInterFace;
}

export interface ExtensionPackageInterFace {
    url: any;
    valueBoolean: any;
}

export interface ExtensionMaternityInterFace {
    url: any;
    valueBoolean: any;
}

export interface ExtensionPharmacistSelectionReasonInterFace {
    url: any;
    valueCodeableConcept: categoryInterFace;
}
export interface PayloadExtensionObj {
    url: any;
    valuePositiveInt: any;
}
export interface PayloadExtension {
    extension: PayloadExtensionObj[];
}

//-------------------------------


export interface extensionItem {
    url?: string;
    valueCodeableConcept?: categoryInterFace
    valueDateTime?: Date
}
@Injectable()
export class FhirService {
    defaultUserBranch: number;
    fhirJsonObj: any
    fhirJsonText: any;
    priAuthJson: any
    cancelJson: any
    pollJson: any
    unSoloicitedCommunication: any;
    claimJson: any
    checkStatusJson: any;
    vitalSignJsonArr: any
    fhirPriAuthorizationValidationMsg: any
    message: any = {}
    constructor(private loaderService: LoaderService,
        private _authService: AuthService,
        public datepipe: DatePipe,
        private _entityService: EntityService,
        @Inject(DOCUMENT) private document: any
    ) {
        _authService.fetchuserInfo().subscribe(c => { if (c && c.userID) this.defaultUserBranch = c.defaultBranch });
    }

    setFormSettings(settingFileName: string, folder?: string) {
        this.loaderService.getSettings(`${settingFileName}_${this.defaultUserBranch == undefined ? 1 : this.defaultUserBranch}`, folder).subscribe(
            v => {
                this.fhirJsonObj = v
                if (settingFileName == 'fhirPriAuthorization') {
                    this.priAuthJson = v
                }
                if (settingFileName == 'fhirCancelReq') {
                    this.cancelJson = v
                }

                if (settingFileName == 'fhirPollReq') {
                    this.pollJson = v
                }
                if (settingFileName == 'fhirUnSoloicitedCommunicationReq') {
                    this.unSoloicitedCommunication = null;
                    this.unSoloicitedCommunication = v
                }
                if (settingFileName == 'fhirClaim') {
                    this.claimJson = v
                }

                if (settingFileName == 'fhirCheckStatusReq') {
                    this.checkStatusJson = v
                }

                if (settingFileName == 'fhirVitalSign') {
                    this.vitalSignJsonArr = v
                }

                if (settingFileName == 'fhirPriAuthorizationValidationMsg') {
                    this.fhirPriAuthorizationValidationMsg = v
                   // console.log('settingFileName__', settingFileName, ' this.fhirPriAuthorizationValidationMsg __', this.fhirPriAuthorizationValidationMsg)
                }


               // console.log('settingFileName__', settingFileName, ' this.fhirJsonObj __', this.fhirJsonObj)
            },
            error => console.log(error),
            () => {

            }
        );
    }

    getCurrentPort(): number {
        return this.document.location.port; // returns 'current used  port' 
    }

    //--------------------------------GENERAL ID----------------------------------
    getRandomId(keyName, KeyVal, json?: any) {
        if (keyName == "bundelId") {
            json['id'] = KeyVal
        }
    }

    getTimeStamp(keyName, KeyVal, json?: any) {
        if (keyName == "timestamp") {
            json['timestamp'] = KeyVal
        }
    }
    returnBackEndProperties(data, messageEvent, jsonForGetFhirJsonTxt, replacedUrl) {
        let nphiesRequestMessagelogObj = <NphiesRequestMessage_log>{}
        nphiesRequestMessagelogObj.bundle_ID = data['guid'];
        nphiesRequestMessagelogObj.messageHeaderID = data['guid'];
        nphiesRequestMessagelogObj.messageEvent_ID = data['guid'];
        nphiesRequestMessagelogObj.messageEvent = messageEvent
        nphiesRequestMessagelogObj.messageEventSubtypes = data.supType
        nphiesRequestMessagelogObj.messageBody = this.getFhirJsonTxt(replacedUrl, data.naphiesReplacedUrl, jsonForGetFhirJsonTxt)
        nphiesRequestMessagelogObj.patientCode = data.patientCode
        nphiesRequestMessagelogObj.isuranceCompany_ID = data.nphiesPayerlicense
        nphiesRequestMessagelogObj.nphiesClaimID = messageEvent == 'PreAuthorizationRequest' ? data['guid'] : data.nphiesClaimID
        nphiesRequestMessagelogObj.visitSerial = data.visitSerial
        nphiesRequestMessagelogObj.approvalRequestMasterSerial = data.approvalRequestMasterSerial
        nphiesRequestMessagelogObj.nphiesType = data.nphiesType
        nphiesRequestMessagelogObj.nphiesRelatedClaimID = data.nphiesClaimID
        nphiesRequestMessagelogObj.nphiesProcessPriority = data.priority ? data.priority : 'normal'
        nphiesRequestMessagelogObj.nphiesCommunicationRequestClaimID = data.nphiesCommunicationRequestClaimID
        nphiesRequestMessagelogObj.nphiesRequestClaimID = data['guid'];
        nphiesRequestMessagelogObj.nphiesPollBundleID = data['guid'];
        nphiesRequestMessagelogObj.nphiesPollMessageHeaderID = data['guid'];
        nphiesRequestMessagelogObj.nphiesPollIdentifierTypeCode = data.identityValNphiesCode
        nphiesRequestMessagelogObj.nphiesPollIdentifierID = data.identityValue1
        nphiesRequestMessagelogObj.proidclaim = data.proidclaim
        nphiesRequestMessagelogObj['approvalRequestSerials'] = data.approvalRequestSerials ? data.approvalRequestSerials : ''
        nphiesRequestMessagelogObj['nphiesAboutCommunicationClaim'] = data.nphiesAboutCommunicationClaim
        nphiesRequestMessagelogObj['nphiesBasedOnCommunicationRequest'] = data.nphiesBasedOnCommunicationRequest

        nphiesRequestMessagelogObj['naphiesUrl'] = data.naphiesUrl
        nphiesRequestMessagelogObj['naphiesUsername'] = data.naphiesUsername
        nphiesRequestMessagelogObj['naphiesPassword'] = data.naphiesPassword

        nphiesRequestMessagelogObj['nphiesCertifiedPath'] = data.nphiesCertifiedPath
        nphiesRequestMessagelogObj['nphiesCertifiesPassword'] = data.nphiesCertifiesPassword
        nphiesRequestMessagelogObj['nphiesEnviroment'] = data.nphiesEnviroment               //// "LIVE"  or "TEST"   fixed string returned from dataBase
        nphiesRequestMessagelogObj['naphiesEnvironmentUrl'] = data.naphiesEnvironmentUrl     //// Choose 1--> live url or 2 -->Test url from UI dropdown
        nphiesRequestMessagelogObj.nphiesEnviromentTestFlag = data.nphiesEnviromentTestFlag  ///// 1 for teset and return fixed poll response in case of certificate - returned from dataBase
        nphiesRequestMessagelogObj['port'] = this.getCurrentPort()                                      
        nphiesRequestMessagelogObj['compFirstLevelCode'] = data.compFirstLevelCode                                  
        nphiesRequestMessagelogObj['compSecondLevelCode']= data.compSecondLevelCode                                   

        console.log('_________REQUEST_OBJ__________', nphiesRequestMessagelogObj)
        //--------------------------------------------------
        return nphiesRequestMessagelogObj
    }

    //------------------Common Data between Nphies Requests----------------------------س----//
    returnNphiesPatientNationalityExtension(data) {
        let nationalityExtension = <any>{}
        let nationalityExtensionvalueCodeableConcept = <any>{}
        let nationalityCodingArr: CodingArr[] = []
        let nationalityCodingObj = <any>{}

        nationalityExtension['url'] = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-nationality"
        nationalityCodingObj['system'] = "urn:iso:std:iso:3166"
        nationalityCodingObj['code'] = data.nphiesNationalityCode
        nationalityCodingObj['display'] = data.nphiesNationalityDisplay
        nationalityCodingArr.push(nationalityCodingObj)
        nationalityExtensionvalueCodeableConcept['coding'] = nationalityCodingArr
        nationalityExtension['valueCodeableConcept'] = nationalityExtensionvalueCodeableConcept
        return nationalityExtension;
    }

    returnNphiesparentOfPatientNationalityExtension(data){
        let parentNationalityExtension = <any>{}
        let parentNationalityExtensionvalueCodeableConcept = <any>{}
        let parentNationalityCodingArr: CodingArr[] = []
        let parentNationalityCodingObj = <any>{}

        parentNationalityExtension['url'] = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-nationality"
        parentNationalityCodingObj['system'] = "urn:iso:std:iso:3166"
        parentNationalityCodingObj['code'] = data.parentdataNphiesNationalityCode
        parentNationalityCodingObj['display'] = data.parentdataNphiesNationalityDisplay
        parentNationalityCodingArr.push(parentNationalityCodingObj)
        parentNationalityExtensionvalueCodeableConcept['coding'] = parentNationalityCodingArr
        parentNationalityExtension['valueCodeableConcept'] = parentNationalityExtensionvalueCodeableConcept
        return parentNationalityExtension;
    }
    //-------------------------------------------ELEGABLILITY----------------------------------
    eligablityResponse: any;

    getEligablityResponse() {
        this.setFormSettings('fhir');
        //this.eligablityResponse= (this.getFhirJsonTxt())
    }

    setEligabilityJson(patData) {
        this.getEligablityResponse()
        let nphiesRequestMessagelogObj = <any>{}
        let _TherapeuticCardsObj = patData._TherapeuticCardsObj
        let messageHeaderIdGuid = patData.messageHeaderIdGuid
        let bundelIdGuid = patData.bundelIdGuid
        let elegabiliyGuid = patData.elegabiliyGuid
        //----------set Pat Data --------
        this.getObjVal('PatientData', patData)  /// Note : if ChildPatData is not exsist ParentPatData = ChildPatData , and  only one resource exsist for patient
        this.getObjVal('NewBornData', patData)
        this.getObjVal('ParentOfPatientData', patData)
        this.getObjVal('provider', patData)
        this.getObjVal('period', patData)
        this.getObjVal('SerivesDate', this.datepipe.transform(new Date(), 'yyyy-MM-dd'))
        this.getObjVal('RoleLocation', { nphiesRoleCodeLocation: patData.nphiesRoleCodeLocation, nphiesRoleCodeLocationDisplay: patData.nphiesRoleCodeLocationDisplay })
        this.getObjVal('focus', elegabiliyGuid)
        this.getObjVal('messageHeaderId', messageHeaderIdGuid)
        this.getRandomId('bundelId', bundelIdGuid, this.fhirJsonObj)
        this.getObjVal('Location', patData)
        this.getObjVal('destination', _TherapeuticCardsObj ? _TherapeuticCardsObj['companyNameEn'] : patData['companyNameEn'])
        this.getObjVal('nphiesID', {
            tpaNphiesId: _TherapeuticCardsObj && _TherapeuticCardsObj['tpaNphiesID'] ? _TherapeuticCardsObj['tpaNphiesID']
                : patData['tpaNphiesID'] ? patData['tpaNphiesID'] : patData.bundelIdGuid, nphiesPayerlicense: patData.nphiesPayerlicense
        }
        )
        this.getObjVal('SourceEndPoint', patData.naphiesReplacedUrl)
        this.getObjVal('Covarage', [patData.naphiesReplacedUrl, _TherapeuticCardsObj, patData.coverageClassList])
        this.getObjVal('PolicyHolder', patData)
        this.getObjVal('ExtensionNewBorn', patData.newBornFlag)
        this.getObjVal('ExtensionEligbilityTransfer', _TherapeuticCardsObj ? _TherapeuticCardsObj['nphiesEligibilityTransferReference'] : null)
        this.getObjVal('EligablityType', patData)
        let date = new Date()
        this.getTimeStamp('timestamp', this.datepipe.transform(date, 'yyyy-MM-ddThh:mm:ss.00+02:00'), this.fhirJsonObj)
        //-----------------Elegablity Req Log -------------------
        nphiesRequestMessagelogObj.serial = 144;
        nphiesRequestMessagelogObj.bundle_ID = bundelIdGuid;
        nphiesRequestMessagelogObj.messageHeaderID = messageHeaderIdGuid;
        nphiesRequestMessagelogObj.messageEvent_ID = messageHeaderIdGuid;
        nphiesRequestMessagelogObj.messageEvent = 'EligibilityRequest'
        nphiesRequestMessagelogObj.messageEventSubtypes = patData.elegabilitySubTypesList.join()
        nphiesRequestMessagelogObj.messageBody = this.getFhirJsonTxt('http://provider.com', patData.naphiesReplacedUrl, this.fhirJsonObj)
        nphiesRequestMessagelogObj.messageResponse = this.eligablityResponse
        nphiesRequestMessagelogObj.patientCode = patData.code
        nphiesRequestMessagelogObj.naphiesUrl = patData.naphiesUrl
        nphiesRequestMessagelogObj.isuranceCompany_ID = patData.nphiesPayerlicense
        nphiesRequestMessagelogObj['nphiesCertifiedPath'] = patData['nphiesCertifiedPath']
        nphiesRequestMessagelogObj['nphiesCertifiesPassword'] = patData['nphiesCertifiesPassword']
        nphiesRequestMessagelogObj['nphiesEnviroment'] = patData['nphiesEnviroment']
        nphiesRequestMessagelogObj['port'] = this.getCurrentPort()
        nphiesRequestMessagelogObj['compFirstLevelCode'] = patData.compFirstLevelCode
        nphiesRequestMessagelogObj['compSecondLevelCode'] = patData.compSecondLevelCode

        //--------------------------------------------------
        this.fhirJsonObj = this.getFhirJsonObj()
        if ((patData.parentdataCode == null || !patData.parentdataCode) && patData['elegabilitySubTypesList'][0] == 'discovery') {
            this.message = JSON.parse(
                nphiesRequestMessagelogObj.messageBody
            );
            let lastIndex = this.message.entry.length - 1;
            this.message.entry.splice(lastIndex, 1); // Removes the second Pattient Object in codition of Self beneficiary
            console.log(this.message.entry);
            nphiesRequestMessagelogObj.messageBody = JSON.stringify(this.message);
        }
        // //--------------------------------------------------
        return nphiesRequestMessagelogObj

    }

    getObjVal(keyName, KeyVal) {

        if (keyName == "PatientData") {
            //-------------Bond Pat Code --------------
            this.fhirJsonObj['entry'][4].resource['id'] = KeyVal.patientCode
            this.fhirJsonObj['entry'][4].fullUrl = `http://provider.com/Patient/${KeyVal.patientCode}`
            this.fhirJsonObj['entry'][1].resource['patient']['reference'] = `http://provider.com/Patient/${KeyVal.patientCode}`
            this.fhirJsonObj['entry'][2].resource['subscriber']['reference'] = `http://provider.com/Patient/${KeyVal.patientCode}`
            this.fhirJsonObj['entry'][2].resource['beneficiary']['reference'] = `http://provider.com/Patient/${KeyVal.patientCode}`
            //  this.fhirJsonObj['entry'][2].resource['subscriberId'] = KeyVal.patientCode
            //----------Bind Birth date ----------
            if (KeyVal['birthDate'] != null  && KeyVal['birthDate'] != 'Unknown') {
                this.fhirJsonObj['entry'][4].resource['birthDate'] = this.datepipe.transform(KeyVal['birthDate'], 'yyyy-MM-dd')
            }
            else {
                delete this.fhirJsonObj['entry'][4].resource['birthDate']
            }
            //---------Bind  Identity Val -----------
            this.fhirJsonObj['entry'][4].resource['identifier'][0]['type']['coding'][0]['code'] = KeyVal.identityValNphiesCode
            this.fhirJsonObj['entry'][4].resource['identifier'][0]['type']['coding'][0]['display'] = KeyVal.identityValNphiesDisplay;
            this.fhirJsonObj['entry'][4].resource['identifier'][0]['system'] = `http://nphies.sa/identifier/${KeyVal.identityValNphiesDisplay}`
            this.fhirJsonObj['entry'][4].resource['identifier'][0]['value'] = KeyVal.identityValue
            this.fhirJsonObj['entry'][2].resource['identifier'][0]['value'] = KeyVal.memberId  //Coverage Resource
            this.fhirJsonObj['entry'][2].resource['subscriberId'] = KeyVal.policyNumber

            //-------Bind Gender-----------------
            this.fhirJsonObj['entry'][4].resource['gender'] = KeyVal.nphiesGenderCode  ?   KeyVal.nphiesGenderCode  :  'unknown' 
            this.fhirJsonObj['entry'][4].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = (KeyVal.nphiesGenderCode  ?   KeyVal.nphiesGenderCode  :  'unknown' )
            this.fhirJsonObj['entry'][4].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['display'] = (KeyVal.nphiesGenderDisplay ? KeyVal.nphiesGenderDisplay : 'Unknown')
            //---------Bind Name-----------
            this.fhirJsonObj['entry'][4].resource['name'][0]['given'] = [KeyVal['fnameEn'], KeyVal['snameEn'], KeyVal['tnameEn']]
            this.fhirJsonObj['entry'][4].resource['name'][0]['text'] = KeyVal.fullnameEn
            this.fhirJsonObj['entry'][4].resource['name'][0]['family'] = KeyVal['tnameEn']
            this.fhirJsonObj['entry'][2].resource['dependent'] = KeyVal.fullnameEn

            //-------Bind Telecome-----------   
            if ((KeyVal.parentdataCode != null || undefined) || KeyVal.mobile == null || undefined) {
                delete this.fhirJsonObj['entry'][4].resource['telecom']
            }
            else if (KeyVal.mobile != null || undefined) {
                this.fhirJsonObj['entry'][4].resource['telecom'][0]['value'] = `+${KeyVal.mobile}`
            }
            //-------Bind Patient Relation ship To Parent-----------   
            this.fhirJsonObj['entry'][2].resource['relationship']['coding'][0]['code'] = KeyVal.nphiesRelationshipCodes
            this.fhirJsonObj['entry'][2].resource['relationship']['coding'][0]['display'] = KeyVal.nphiesRelationshipCodes
            //-------Bind maritalStatus-----------   
            this.fhirJsonObj['entry'][4].resource['maritalStatus']['coding'][0]['code'] = KeyVal.maritalStatusStr
            this.fhirJsonObj['entry'][4].resource['maritalStatus']['coding'][0]['system'] = KeyVal.maritalStatusStr == 'UNK' ? "http://terminology.hl7.org/CodeSystem/v3-NullFlavor" : "http://terminology.hl7.org/CodeSystem/v3-MaritalStatus"
            //-------Bind Patient Occupation-----------   
            this.fhirJsonObj['entry'][4].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.patientOccupationStr
            //-------patient nationality extenstion -------
            if (KeyVal.nphiesNationalityCode) {
                this.fhirJsonObj['entry'][4].resource['extension'].push(this.returnNphiesPatientNationalityExtension(KeyVal))
            }
        }
        if (keyName == 'ParentOfPatientData') {
            if (KeyVal.parentdataCode != null || undefined) {
                //-------------Bond Pat Code --------------
                this.fhirJsonObj['entry'][7].resource['id'] = KeyVal.parentdataCode
                this.fhirJsonObj['entry'][7].fullUrl = `http://provider.com/Patient/${KeyVal.parentdataCode}`
                this.fhirJsonObj['entry'][2].resource['subscriber']['reference'] = `http://provider.com/Patient/${KeyVal.parentdataCode}`
                //----------Bind Birth date ----------
                if ((KeyVal['parentdataBirthDate'] != null ) && (KeyVal['parentdataBirthDate'] != "Unknown" )) {
                    this.fhirJsonObj['entry'][7].resource['birthDate'] = this.datepipe.transform(KeyVal['parentdataBirthDate'], 'yyyy-MM-dd')
                }
                else {
                    delete  this.fhirJsonObj['entry'][7].resource['birthDate'] 
                }
                //---------Bind  Identity Val -----------
                this.fhirJsonObj['entry'][7].resource['identifier'][0]['type']['coding'][0]['code'] = KeyVal.parentdataIdentityValNphiesCode
                this.fhirJsonObj['entry'][7].resource['identifier'][0]['type']['coding'][0]['display'] = KeyVal.parentdataIdentityValNphiesDisplay;
                this.fhirJsonObj['entry'][7].resource['identifier'][0]['system'] = `http://nphies.sa/identifier/${KeyVal.parentdataIdentityValNphiesDisplay}`
                this.fhirJsonObj['entry'][7].resource['identifier'][0]['value'] = KeyVal.parentdataIdentityValue
                this.fhirJsonObj['entry'][2].resource['identifier'][0]['value'] = KeyVal.parentdataIdentityValue
                //-------Bind Gender-----------------
                this.fhirJsonObj['entry'][7].resource['gender'] = (KeyVal.nphiesParentGenderCode ?  KeyVal.nphiesParentGenderCode   : "unknown")
                this.fhirJsonObj['entry'][7].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['code'] =(KeyVal.nphiesParentGenderCode ?  KeyVal.nphiesParentGenderCode   : "unknown")
                this.fhirJsonObj['entry'][7].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['display'] =(KeyVal.nphiesParentGenderDisplay ?  KeyVal.nphiesParentGenderDisplay   : "Unknown")
                //---------Bind Name-----------
                this.fhirJsonObj['entry'][7].resource['name'][0]['given'] = [KeyVal['parentdatafnameEn'], KeyVal['parentdatasnameEn'], KeyVal['parentdatatnameEn']]
                this.fhirJsonObj['entry'][7].resource['name'][0]['text'] = KeyVal.parentdatafullnameEn
                //-------Bind Telecome-----------
                this.fhirJsonObj['entry'][7].resource['telecom'][0]['value'] = `+${KeyVal.parentdataMobile}`
                //-------Bind maritalStatus-----------   
                this.fhirJsonObj['entry'][7].resource['maritalStatus']['coding'][0]['code'] = KeyVal.patMaritalStatus
                this.fhirJsonObj['entry'][7].resource['maritalStatus']['coding'][0]['system'] = KeyVal.patMaritalStatus == 'UNK' ? "http://terminology.hl7.org/CodeSystem/v3-NullFlavor" : "http://terminology.hl7.org/CodeSystem/v3-MaritalStatus"

                //-------Bind Parent Patient Occupation-----------   
                this.fhirJsonObj['entry'][7].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.parentdataOccupationStr
                //-------parent of patient nationality extenstion -------
                if (KeyVal.parentdataNphiesNationalityCode) {
                    this.fhirJsonObj['entry'][7].resource['extension'].push(this.returnNphiesparentOfPatientNationalityExtension(KeyVal))
                }
                //----------------------------------------------------//
            }

        }

        if (keyName == 'NewBornData') {
            if (KeyVal.newBornFlag) {
                //-------------Bond Pat Code --------------
                this.fhirJsonObj['entry'][7].resource['id'] = KeyVal.newBornMrn
                this.fhirJsonObj['entry'][7].fullUrl = `http://provider.com/Patient/${KeyVal.newBornMrn}`
                this.fhirJsonObj['entry'][2].resource['subscriber']['reference'] = `http://provider.com/Patient/${KeyVal.newBornMrn}`
                //----------Bind Birth date ----------
              
                if (KeyVal['newBornBirthDate'] != null &&  KeyVal['newBornBirthDate'] != 'Unknown') {
                    this.fhirJsonObj['entry'][7].resource['birthDate'] = this.datepipe.transform(KeyVal['newBornBirthDate'], 'yyyy-MM-dd')
                }
                else {
                    delete  this.fhirJsonObj['entry'][7].resource['birthDate'] 
                }
                //---------Bind  Identity Val -----------
                this.fhirJsonObj['entry'][7].resource['identifier'][0]['type']['coding'][0]['code'] = KeyVal.newBornMrnNphiesCode
                this.fhirJsonObj['entry'][7].resource['identifier'][0]['type']['coding'][0]['display'] = KeyVal.newBornMrnNphiesDisplay;
                this.fhirJsonObj['entry'][7].resource['identifier'][0]['system'] = `http://nphies.sa/identifier/${KeyVal.newBornMrnNphiesDisplay}`
                this.fhirJsonObj['entry'][7].resource['identifier'][0]['value'] = KeyVal.newBornMrn
                this.fhirJsonObj['entry'][2].resource['identifier'][0]['value'] = KeyVal.newBornMrn
                //-------Bind Gender-----------------
                this.fhirJsonObj['entry'][7].resource['gender'] = (KeyVal.newBornGenderCode ?  KeyVal.newBornGenderCode   : "unknown")
                this.fhirJsonObj['entry'][7].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['code'] =(KeyVal.newBornGenderCode ?  KeyVal.newBornGenderCode   : "unknown")
                this.fhirJsonObj['entry'][7].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['display'] =(KeyVal.newBornGenderDisplay ?  KeyVal.newBornGenderDisplay   : "Unknown")
                //---------Bind Name-----------
                this.fhirJsonObj['entry'][7].resource['name'][0]['given'] = [KeyVal['newBornfnameEn'], KeyVal['newBornsnameEn'], KeyVal['newBorntnameEn']]
                this.fhirJsonObj['entry'][7].resource['name'][0]['text'] = KeyVal.newBornFullName
                this.fhirJsonObj['entry'][7].resource['name'][0]['family'] = KeyVal['newBorntnameEn']
                //-------Bind Telecome-----------
                if (KeyVal.mobile != null || undefined) {
                    this.fhirJsonObj['entry'][7].resource['telecom'][0]['value'] = `+${KeyVal.mobile}`
                }
                //-------Bind maritalStatus-----------   
                this.fhirJsonObj['entry'][7].resource['maritalStatus']['coding'][0]['code'] = KeyVal.newBornMaritalStatus
                this.fhirJsonObj['entry'][7].resource['maritalStatus']['coding'][0]['system'] = KeyVal.newBornMaritalStatus == 'UNK' ? "http://terminology.hl7.org/CodeSystem/v3-NullFlavor" : "http://terminology.hl7.org/CodeSystem/v3-MaritalStatus"

                //-------Bind Parent Patient Occupation-----------   
                this.fhirJsonObj['entry'][7].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.newBornOccupationStr
                //-------parent of patient nationality extenstion -------
                if (KeyVal.parentdataNphiesNationalityCode) {
                    this.fhirJsonObj['entry'][7].resource['extension'].push(this.returnNphiesparentOfPatientNationalityExtension(KeyVal))
                }
                //----------------------------------------------------//
            }

        }
        if (keyName == "destination") {
            this.fhirJsonObj['entry'][5].resource['name'] = KeyVal
        }
        if (keyName == "provider") {
            this.fhirJsonObj['entry'][3].resource['id'] = KeyVal.branchCode
            this.fhirJsonObj['entry'][3].resource['name'] = KeyVal.branchName
            this.fhirJsonObj['entry'][3].fullUrl = `http://provider.com/Organization/${KeyVal.branchCode}`
            this.fhirJsonObj['entry'][1].resource['provider']['reference'] = `http://provider.com/Organization/${KeyVal.branchCode}`
            this.fhirJsonObj['entry'][6].resource['managingOrganization']['reference'] = `http://provider.com/Organization/${KeyVal.branchCode}`
            this.fhirJsonObj['entry'][5].resource['identifier'][0]['value'] = KeyVal.nphiesPayerlicense
            this.fhirJsonObj['entry'][0].resource['destination'][0]['endpoint'] = `http://nphies.sa/license/payer-license/${KeyVal._TherapeuticCardsObj.tpaNphiesID}`
            this.fhirJsonObj['entry'][0].resource['destination'][0]['receiver']['identifier']['value'] = KeyVal._TherapeuticCardsObj.tpaNphiesID
            this.fhirJsonObj['entry'][0].resource['sender']['identifier']['value'] = KeyVal.nphiesProviderlicense
            this.fhirJsonObj['entry'][0].resource['source']['endpoint'] = `http://nphies.sa/license/payer-license/${KeyVal.nphiesProviderlicense}`
            this.fhirJsonObj['entry'][3].resource['identifier'][0]['value'] = KeyVal.nphiesProviderlicense
            this.fhirJsonObj['entry'][3].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.nphiesProviderTypeCode
            this.fhirJsonObj['entry'][3].resource['extension'][0]['valueCodeableConcept']['coding'][0]['display'] = KeyVal.nphiesProviderTypeDisplay

        }
        if (keyName == "RoleLocation") {

            console.log(this.fhirJsonObj['entry'])
            this.fhirJsonObj['entry'][6].resource['identifier'][0]['value'] = KeyVal['nphiesRoleCodeLocation'] ? KeyVal['nphiesRoleCodeLocation'] : this.fhirJsonObj['entry'][6].resource['identifier'][0]['value']
            this.fhirJsonObj['entry'][6].resource['type'][0]['coding'][0]['code'] = KeyVal['nphiesRoleCodeLocation'] ? KeyVal['nphiesRoleCodeLocation'] : this.fhirJsonObj['entry'][6].resource['type'][0]['coding'][0]['code']
            this.fhirJsonObj['entry'][6].resource['name'] = KeyVal['nphiesRoleCodeLocationDisplay'] ? KeyVal['nphiesRoleCodeLocationDisplay'] : this.fhirJsonObj['entry'][6].resource['name'] = KeyVal['nphiesRoleCodeLocationDisplay']
        }
        if (keyName == "nphiesID") {
            this.fhirJsonObj['entry'][1].resource['insurer']['reference'] = `http://provider.com/Organization/${KeyVal.nphiesPayerlicense}`
            this.fhirJsonObj['entry'][2].resource['payor'][0]['reference'] = `http://provider.com/Organization/${KeyVal.nphiesPayerlicense}`
            this.fhirJsonObj['entry'][5].resource['id'] = KeyVal.nphiesPayerlicense
            this.fhirJsonObj['entry'][5].fullUrl = `http://provider.com/Organization/${KeyVal.nphiesPayerlicense}`
        }
        if (keyName == "Location") {
            this.fhirJsonObj['entry'][1].resource['facility']['reference'] = `http://provider.com/Location/${KeyVal.bundelIdGuid}`
            this.fhirJsonObj['entry'][6].resource['id'] = KeyVal.bundelIdGuid
            this.fhirJsonObj['entry'][6].fullUrl = `http://provider.com/Location/${KeyVal.bundelIdGuid}`
        }
        if (keyName == "focus") {
            this.fhirJsonObj['entry'][0].resource[keyName][0]['reference'] = `http://provider.com/CoverageEligibilityRequest/${KeyVal}`
            this.fhirJsonObj['entry'][1].resource['identifier'][0]['value'] = KeyVal
            this.fhirJsonObj['entry'][1].resource['id'] = KeyVal
            this.fhirJsonObj['entry'][1].fullUrl = `http://provider.com/CoverageEligibilityRequest/${KeyVal}`
        }
        if (keyName == "messageHeaderId") {
            this.fhirJsonObj['entry'][0].resource['id'] = KeyVal
            this.fhirJsonObj['entry'][0].fullUrl = `urn:uuid:${KeyVal}`
        }
        if (keyName == "SourceEndPoint") {
            this.fhirJsonObj['entry'][0].resource['source']['endpoint'] = KeyVal
        }
        if (keyName == "Covarage") {
            this.fhirJsonObj['entry'][2].fullUrl = `${KeyVal[0]}/Coverage/1333`
            this.fhirJsonObj['entry'][2].resource['identifier'][0]['value'] = `${KeyVal[1].cardNo}`
            this.fhirJsonObj['entry'][1].resource['insurance'][0]['coverage']['reference'] = `${KeyVal[0]}/Coverage/1333`

            /// Bind Coverage Data List  /////
            if (KeyVal[2] && KeyVal[2].length > 0) {
                if (!this.fhirJsonObj['entry'][2].resource['class']) {
                    this.fhirJsonObj['entry'][2].resource['class'] = []
                }
                this.fhirJsonObj['entry'][2].resource['class'] = this.prepareAndReturnCoverageClassListToBind(KeyVal[2])
            }

        }
        if (keyName == "PolicyHolder") {
            this.fhirJsonObj['entry'][2].resource.policyHolder.reference = `http://provider.com/Organization/${KeyVal.elegabiliyGuid}`
            this.fhirJsonObj['entry'][8].fullUrl = `http://provider.com/Organization/${KeyVal.elegabiliyGuid}`
            this.fhirJsonObj['entry'][8].resource.id = KeyVal.elegabiliyGuid
            this.fhirJsonObj['entry'][8].resource.identifier[0]['value'] = KeyVal.policyNumber
            this.fhirJsonObj['entry'][8].resource.name = KeyVal.policyholder

        }
        if (keyName == "SerivesDate") {
            this.fhirJsonObj['entry'][1].resource['servicedPeriod']['start'] = KeyVal
            this.fhirJsonObj['entry'][1].resource['servicedPeriod']['end'] = KeyVal
            this.fhirJsonObj['entry'][1].resource['created'] = KeyVal
        }
        if (keyName == 'ExtensionEligbilityTransfer') {
            let extensionTransferObj = <any>{}
            if (KeyVal && KeyVal != null) {
                extensionTransferObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-transfer"
                extensionTransferObj.valueBoolean = true

                if (!this.fhirJsonObj['entry'][1].resource['extension']) {
                    this.fhirJsonObj['entry'][1].resource['extension'] = []
                }
                this.fhirJsonObj['entry'][1].resource['extension'].push(extensionTransferObj)
            }
        }
        if (keyName == 'ExtensionNewBorn') {
            let extensionNewBornObj = <any>{}
            if (KeyVal == 1) {
                extensionNewBornObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-newborn"
                extensionNewBornObj.valueBoolean = true

                if (!this.fhirJsonObj['entry'][1].resource['extension']) {
                    this.fhirJsonObj['entry'][1].resource['extension'] = []
                }
                this.fhirJsonObj['entry'][1].resource['extension'].push(extensionNewBornObj)
            }
        }
        if (keyName == "EligablityType") {

            this.fhirJsonObj['entry'][1].resource['purpose'] = []
            this.fhirJsonObj['entry'][1].resource['purpose'] = KeyVal.elegabilitySubTypesList

            if (KeyVal['elegabilitySubTypesList'].includes("discovery")) {
                delete this.fhirJsonObj['entry'][1].resource['insurance']
                //this.fhirJsonObj['entry'].splice(2, 1);    ///  Delete Covarage resource
                this.fhirJsonObj['entry'][2]['SpliceFromEntryFlag'] = true
            }

           if (  (KeyVal.parentdataCode == null || undefined ) && (!KeyVal.newBornFlag  && !KeyVal.newBornMrn) ) {
              //  this.fhirJsonObj['entry'].splice(7, 1);    ///  Delete Parent of patient  resource
                this.fhirJsonObj['entry'][7]['SpliceFromEntryFlag'] = true
            }

            this.fhirJsonObj['entry'] = this.fhirJsonObj['entry'].filter(ele => !ele['SpliceFromEntryFlag'])
            console.log('fhirJsonObj', this.fhirJsonObj)

        }
    }

    //-------------------------------------------PRIAUTHORIZATION-----------------------------------

    setPriAuthorizationJson(patServiceData) {
        this.setFormSettings('fhirPriAuthorization');
        let messageHeaderIdGuid = patServiceData['guid']
        let bundelIdGuid = patServiceData['guid']
        let visitserialGuid = patServiceData['guid']
        let date = new Date()
        patServiceData.currentDate = date
        this.getRandomId('bundelId', bundelIdGuid, this.priAuthJson)
        this.replaceAuthVals('messageHeaderId', messageHeaderIdGuid)
        //------------Not : VisitSerial Repalced by GUID Permanently
        this.replaceAuthVals('claimId', visitserialGuid)
        //////////////////////////////////////////////////////////////////////////
        this.replaceAuthVals('insurer', { tpaNphiesID: patServiceData.tpaNphiesID, tpaNphiesNameEn: patServiceData.tpaNphiesNameEn, nphiesPayerlicense: patServiceData.nphiesPayerlicense })
        this.replaceAuthVals('CoverageData', patServiceData);
        this.replaceAuthVals('PolicyHolder', patServiceData);


        //-------------------------------------------
        this.replaceAuthVals('PatientData', patServiceData)
        this.replaceAuthVals('ParentOfPatientData', patServiceData)
        //-------------------------------------------
        this.replaceAuthVals('careTeam', patServiceData.docId)
        this.replaceAuthVals('DocFullNameText', patServiceData.docNameEn)
        this.replaceAuthVals('DocNameArr', [patServiceData.docFnameEn, patServiceData.docSnameEn, patServiceData.docTnameEn])
        this.replaceAuthVals('familyDocName', patServiceData.docLnameEn)

        // -----------------------------
        this.replaceAuthVals('diagnosisList', patServiceData.patDiagnosis)
        this.replaceAuthVals('SupportingInfo', patServiceData.ucafTempleteData)
        this.replaceAuthVals('ProductOrService', patServiceData.ucafTempleteData)

        this.replaceAuthVals('priority', patServiceData.priority)
        this.replaceAuthVals('Practionerlicense', patServiceData.practionerlicense)
        this.replaceAuthVals('PractionerRole', patServiceData)
        this.replaceAuthVals('qualification', patServiceData)

        this.replaceAuthVals('nphiesrelatedClaimObj', patServiceData.nphiesrelatedClaimObj)

        this.getTimeStamp('timestamp', this.datepipe.transform(date, 'yyyy-MM-ddThh:mm:ss.00+02:00'), this.priAuthJson)
        this.replaceAuthVals('NphiesProvID', patServiceData)
        this.replaceAuthVals('createdDate', this.datepipe.transform(patServiceData.reqDate, 'yyyy-MM-dd'))
        this.replaceAuthVals('visionprescriptionData', patServiceData)
        this.replaceAuthVals('NphiesPayerlicense', patServiceData.tpaNphiesID)
        this.replaceAuthVals('NphiesProviderlicense', patServiceData.nphiesProviderlicense)
        this.replaceAuthVals('extensionTransfer', patServiceData.extensionTransfer)
        this.replaceAuthVals('extensionEligibility', patServiceData.extensionEligibility)
        this.replaceAuthVals('ExtensionEligibilityResponse', patServiceData.extensionEligibilityResponse);
        this.replaceAuthVals('extensionEncounter', patServiceData.extensionEncounter)
        this.replaceAuthVals('ExtensionNewBorn', patServiceData.newBornFlag)
        this.replaceAuthVals('referral', patServiceData.inTransferBodies)

        this.replaceAuthVals('AuthorizationType', patServiceData)
        //-----------------Authorization Req Log -------------------
        return this.returnBackEndProperties(patServiceData, 'PreAuthorizationRequest', this.priAuthJson, 'http://sgh.com.sa')
    }
    diagnosisSequensList = [];
    replaceAuthVals(keyName, KeyVal) {
        if (keyName == "messageHeaderId") {
            if (KeyVal) {
                this.priAuthJson['entry'][0].resource['id'] = KeyVal
                this.priAuthJson['entry'][0].fullUrl = `urn:uuid:${KeyVal}`
            }
        }
        if (keyName == "claimId") {
            if (KeyVal) {
                this.priAuthJson['entry'][0].resource['focus'][0]['reference'] = `http://sgh.com.sa/Claim/${KeyVal}`
                this.priAuthJson['entry'][1].fullUrl = `http://sgh.com.sa/Claim/${KeyVal}`
                this.priAuthJson['entry'][1].resource['id'] = KeyVal
                this.priAuthJson['entry'][1].resource['identifier'][0]['value'] = KeyVal
            }
        }
        if (keyName == "PatientData") {
            //-------------Bond Pat Code --------------
            this.priAuthJson['entry'][1].resource['patient']['reference'] = `http://sgh.com.sa/Patient/${KeyVal.patientCode}`
            this.priAuthJson['entry'][3].fullUrl = `http://sgh.com.sa/Patient/${KeyVal.patientCode}`
            this.priAuthJson['entry'][3].resource['id'] = KeyVal.patientCode
            this.priAuthJson['entry'][5].resource['beneficiary']['reference'] = `http://sgh.com.sa/Patient/${KeyVal.patientCode}`
            this.priAuthJson['entry'][5].resource['subscriber']['reference'] = `http://sgh.com.sa/Patient/${KeyVal.patientCode}`

            this.priAuthJson['entry'][9].resource['subject']['reference'] = `http://sgh.com.sa/Patient/${KeyVal.patientCode}`  //--Encounter_Resource
            this.priAuthJson['entry'][7].resource['patient']['reference'] = `http://sgh.com.sa/Patient/${KeyVal.patientCode}`  //--VisionPrescription_Resource
            //----------Bind Birth date ----------
            this.priAuthJson['entry'][3].resource['birthDate'] = this.datepipe.transform(KeyVal['birthDate'], 'yyyy-MM-dd')
            //---------Bind  Identity Val -----------
            this.priAuthJson['entry'][3].resource['identifier'][0]['type']['coding'][0]['code'] = KeyVal.identityValNphiesCode
            this.priAuthJson['entry'][3].resource['identifier'][0]['type']['coding'][0]['display'] = KeyVal.identityValNphiesDisplay;
            this.priAuthJson['entry'][3].resource['identifier'][0]['system'] = `http://nphies.sa/identifier/${KeyVal.identityValNphiesDisplay}`
            this.priAuthJson['entry'][3].resource['identifier'][0]['value'] = KeyVal.identityValue
            this.priAuthJson['entry'][5].resource['identifier'][0]['value'] = KeyVal.memberId  //Coverage Resource
            //-------Bind Gender-----------------
            this.priAuthJson['entry'][3].resource['gender'] =KeyVal.nphiesGenderCode  ?   KeyVal.nphiesGenderCode  :  'unknown' 
            this.priAuthJson['entry'][3].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.nphiesGenderCode  ?   KeyVal.nphiesGenderCode  :  'unknown' 
            this.priAuthJson['entry'][3].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['display'] =KeyVal.nphiesGenderDisplay  ?   KeyVal.nphiesGenderDisplay  :  'Unknown' 
            //---------Bind Name-----------
            this.priAuthJson['entry'][3].resource['name'][0]['given'] = [KeyVal.fnameEn, KeyVal.snameEn]
            this.priAuthJson['entry'][3].resource['name'][0]['text'] = KeyVal.fullnameEn
            this.priAuthJson['entry'][3].resource['name'][0]['family'] = KeyVal.tnameEn

            //----------Bind Telecome -------------   
            if (KeyVal.parentdataCode != null || undefined) {
                delete this.priAuthJson['entry'][3].resource['telecom']
            }
            else {
                this.priAuthJson['entry'][3].resource['telecom'][0]['value'] = `+${KeyVal.mobile}`
            }
            //-------Bind Patient Relation ship To Parent-----------   
            this.priAuthJson['entry'][5].resource['relationship']['coding'][0]['code'] = KeyVal.nphiesRelationshipCodes
            //--------Bind MaritalStatus-----------
            this.priAuthJson['entry'][3].resource['maritalStatus']['coding'][0]['code'] = KeyVal.maritalStatus
            this.priAuthJson['entry'][3].resource['maritalStatus']['coding'][0]['system'] = KeyVal.maritalStatus == 'UNK' ? "http://terminology.hl7.org/CodeSystem/v3-NullFlavor" : "http://terminology.hl7.org/CodeSystem/v3-MaritalStatus"

            //-------Bind Patient Occupatient-----------  
            this.priAuthJson['entry'][3].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.patientOccupation

            //-------patient nationality extenstion -------
            if (KeyVal.nphiesNationalityCode) {
                this.priAuthJson['entry'][3].resource['extension'].push(this.returnNphiesPatientNationalityExtension(KeyVal))
            }

        }

        if (keyName == 'ParentOfPatientData') {
            if (KeyVal.parentdataCode != null || undefined) {
                //-------------Bond Pat Code --------------
                this.priAuthJson['entry'][8].resource['id'] = KeyVal.parentdataCode
                this.priAuthJson['entry'][8].fullUrl = `http://provider.com/Patient/${KeyVal.parentdataCode}`
                this.priAuthJson['entry'][5].resource['subscriber']['reference'] = `http://provider.com/Patient/${KeyVal.parentdataCode}`

                //----------Bind Birth date ----------
                this.priAuthJson['entry'][8].resource['birthDate'] = this.datepipe.transform(KeyVal['parentdataBirthDate'], 'yyyy-MM-dd')
                //---------Bind  Identity Val -----------
                this.priAuthJson['entry'][8].resource['identifier'][0]['type']['coding'][0]['code'] = KeyVal.parentdataIdentityValNphiesCode
                this.priAuthJson['entry'][8].resource['identifier'][0]['type']['coding'][0]['display'] = KeyVal.parentdataIdentityValNphiesDisplay;
                this.priAuthJson['entry'][8].resource['identifier'][0]['system'] = `http://nphies.sa/identifier/${KeyVal.parentdataIdentityValNphiesDisplay}`
                this.priAuthJson['entry'][8].resource['identifier'][0]['value'] = KeyVal.parentdataIdentityValue
                //-------Bind Gender-----------------
                this.priAuthJson['entry'][8].resource['gender'] = KeyVal.nphiesParentGenderCode   ?   KeyVal.nphiesParentGenderCode  :  'unknown'
                this.priAuthJson['entry'][8].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.nphiesParentGenderCode   ?   KeyVal.nphiesParentGenderCode  :  'unknown'
                this.priAuthJson['entry'][8].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['display'] = KeyVal.nphiesParentGenderDisplay   ?   KeyVal.nphiesParentGenderDisplay  :  'Unknown'
                //---------Bind Name-----------
                this.priAuthJson['entry'][8].resource['name'][0]['given'] = [KeyVal['parentdatafnameEn'], KeyVal['parentdatasnameEn'], KeyVal['parentdatatnameEn']]
                this.priAuthJson['entry'][8].resource['name'][0]['text'] = KeyVal.parentdatafullnameEn
                //-------Bind Telecome-----------
                this.priAuthJson['entry'][8].resource['telecom'][0]['value'] = `+${KeyVal.parentdataMobile}`
                //--------Bind Parent MaritalStatus-----------
                this.priAuthJson['entry'][8].resource['maritalStatus']['coding'][0]['code'] = KeyVal.parentdataMaritalStatus
                this.priAuthJson['entry'][8].resource['maritalStatus']['coding'][0]['system'] = KeyVal.parentdataMaritalStatus == 'UNK' ? "http://terminology.hl7.org/CodeSystem/v3-NullFlavor" : "http://terminology.hl7.org/CodeSystem/v3-MaritalStatus"

                //-------Bind Patient Occupatient-----------  
                this.priAuthJson['entry'][8].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.parentdataOccupation
                //-------parent of patient nationality extenstion -------
                if (KeyVal.parentdataNphiesNationalityCode) {
                    this.priAuthJson['entry'][8].resource['extension'].push(this.returnNphiesparentOfPatientNationalityExtension(KeyVal))
                }
                //----------------------------------------------------//
            }

        }
      
        if (keyName == "insurer") {
            if (KeyVal) {
                this.priAuthJson['entry'][1].resource['insurer']['reference'] = `http://sgh.com.sa/Organization/${KeyVal.nphiesPayerlicense}`
                this.priAuthJson['entry'][5].resource['payor'][0]['reference'] = `http://sgh.com.sa/Organization/${KeyVal.nphiesPayerlicense}`
                this.priAuthJson['entry'][4].fullUrl = `http://sgh.com.sa/Organization/${KeyVal.nphiesPayerlicense}`
                this.priAuthJson['entry'][4].resource['id'] = KeyVal.nphiesPayerlicense
                this.priAuthJson['entry'][4].resource['name'] = KeyVal.tpaNphiesNameEn
            }
        }
        if (keyName == 'CoverageData') {
            // this.priAuthJson['entry'][5].resource['class'][0]['type']['coding'][0]['code'] = KeyVal.coverageClass
            // this.priAuthJson['entry'][5].resource['class'][0]['value'] = KeyVal.coverageValue
            // this.priAuthJson['entry'][5].resource['class'][0]['name'] = KeyVal.coverageName
            this.priAuthJson['entry'][5].resource['type']['coding'][0]['code'] = KeyVal.coverageType
            this.priAuthJson['entry'][5].resource['network'] = KeyVal.coverageNetwork

            /// Bind Coverage Data List  /////
            if (KeyVal.CoverageData && KeyVal.CoverageData.length > 0) {
                if (!this.priAuthJson['entry'][5].resource['class']) {
                    this.priAuthJson['entry'][5].resource['class'] = []
                }
                this.priAuthJson['entry'][5].resource['class'] = this.prepareAndReturnCoverageClassListToBind(KeyVal.CoverageData)
            }


        }
        if (keyName == "PolicyHolder") {
            this.priAuthJson['entry'][5].resource.policyHolder.reference = `http://provider.com/Organization/${KeyVal.guid}`
            this.priAuthJson['entry'][10].fullUrl = `http://provider.com/Organization/${KeyVal.guid}`
            this.priAuthJson['entry'][10].resource.id = KeyVal.guid
            this.priAuthJson['entry'][10].resource.identifier[0]['value'] = KeyVal.policyNumber
            this.priAuthJson['entry'][10].resource.name = KeyVal.policyholder

        }
        if (keyName == "NphiesPayerlicense") {
            if (KeyVal) {
                this.priAuthJson['entry'][4].resource['identifier'][0]['value'] = KeyVal
                this.priAuthJson['entry'][0].resource['destination'][0]['endpoint'] = `http://nphies.sa/license/payer-license/${KeyVal}`
                this.priAuthJson['entry'][0].resource['destination'][0]['receiver']['identifier']['value'] = KeyVal
            }
        }
        if (keyName == "NphiesProviderlicense") {
            this.priAuthJson['entry'][2].resource['identifier'][0]['value'] = KeyVal ? KeyVal : null
            this.priAuthJson['entry'][0].resource['source']['endpoint'] = `http://sgh.com.sa`
            this.priAuthJson['entry'][0].resource['sender']['identifier']['value'] = KeyVal ? KeyVal : null
        }
        if (keyName == "careTeam") {
            if (KeyVal) {
                this.priAuthJson['entry'][6].fullUrl = `http://sgh.com.sa/Practitioner/${KeyVal}`
                this.priAuthJson['entry'][6].resource['id'] = KeyVal
                this.priAuthJson['entry'][1].resource['careTeam'][0]['provider']['reference'] = `http://sgh.com.sa/Practitioner/${KeyVal}`
                this.priAuthJson['entry'][11].resource['practitioner']['reference'] = `http://sgh.com.sa/Practitioner/${KeyVal}`
            }
        }
        if (keyName == "DocFullNameText") {
            if (KeyVal) {
                this.priAuthJson['entry'][6].resource['name'][0]['text'] = KeyVal
            }
        }
        if (keyName == "DocNameArr") {
            if (KeyVal) {
                this.priAuthJson['entry'][6].resource['name'][0]['given'] = KeyVal
            }
        }
        if (keyName == "familyDocName") {
            if (KeyVal) {
                this.priAuthJson['entry'][6].resource['name'][0]['family'] = KeyVal
            }
        }
        if (keyName == "createdDate") {
            if (KeyVal) {
                this.priAuthJson['entry'][1].resource['created'] = KeyVal
            }
        }
        if (keyName == 'ProductOrService') {
            if (KeyVal.productOrServiceList) {
                let ItemMajorInterFaceObj = <ItemMajorInterFace>{}
                let productOrServiceCoding = <productOrServiceCodingArr>{}
                let ExtensionTaxeObj = <ExtensionTaxInterFace>{}
                let ExtensionPatientShareObj = <ExtensionPatientShareInterFace>{}
                let ExtensionPatientInvoiceObj = <ExtensionPatientInvoiceInterFace>{}
                let ExtensionPackageObj = <ExtensionPackageInterFace>{}
                let ExtensionMaternityObj = <ExtensionMaternityInterFace>{}

                let ExtensionPharmacistSelectionReasonObj = <ExtensionPharmacistSelectionReasonInterFace>{}
                let CodingObj = <CodingArr>{}
                let ItemMajorArr = []
                let ServNameArr = []
                let TotalNet = 0
                let diagnosesSquanceList = []
                ////////////////////////____To Get Diagnosis sequance count Arr____
                this.priAuthJson['entry'][1].resource['diagnosis'].forEach((ele, index) => {
                    diagnosesSquanceList.push(ele.sequence)
                });
                //-----------------------------------------------------------
                let exyensionTempArr = []
                exyensionTempArr = [...this.priAuthJson['entry'][1].resource['item'][0]['extension']]
                //------------------------------------------------------------


                KeyVal.productOrServiceList.forEach((ele) => {
                    if (ele != undefined) {
                        let tax: number = 0
                        let itemsBodySitesArrCopy
                        ExtensionTaxeObj = <ExtensionTaxInterFace>{}
                        ExtensionPatientShareObj = <ExtensionPatientShareInterFace>{}
                        ExtensionPatientInvoiceObj = <ExtensionPatientInvoiceInterFace>{}
                        ExtensionPackageObj = <ExtensionPackageInterFace>{}
                        ExtensionMaternityObj = <ExtensionMaternityInterFace>{}
                        ExtensionPharmacistSelectionReasonObj = <ExtensionPharmacistSelectionReasonInterFace>{}
                        ItemMajorInterFaceObj = <ItemMajorInterFace>{}
                        ItemMajorInterFaceObj.productOrService = <productOrServiceCodingArr>{}
                        ItemMajorInterFaceObj.productOrService.coding = []
                        productOrServiceCoding = <productOrServiceCodingArr>{}
                        ItemMajorInterFaceObj.unitPrice = <unitPriceAndNet>{}
                        ItemMajorInterFaceObj.net = <unitPriceAndNet>{}
                        ItemMajorInterFaceObj.net.value = 0
                        productOrServiceCoding.coding = []
                        productOrServiceCoding.text = ''
                        ItemMajorInterFaceObj.quantity = <any>{}
                        CodingObj = <CodingArr>{}
                        let bodySiteObj = <CodingArr>{}
                        ItemMajorInterFaceObj.bodySite = <bodySiteArr>{}
                        ItemMajorInterFaceObj.bodySite.coding = [];
                        ItemMajorInterFaceObj.factor = 0
                        //--------------------- الخاص بيه ف حاله الادويه فق supporting info بال item عشان اربط كل 
                        if (KeyVal['DiagwithDaysSupplyPhamacyList'] && KeyVal['DiagwithDaysSupplyPhamacyList'].length > 0 && KeyVal['supType'] == 'pharmacy') {
                            ItemMajorInterFaceObj.informationSequence = []
                            let DiagwithDaysSupplyPhamacyObj = KeyVal['DiagwithDaysSupplyPhamacyList'].find(item => item['codeHyphanated'] == ele['codeHyphanated'])
                            let xc
                            if (DiagwithDaysSupplyPhamacyObj) {
                                xc = DiagwithDaysSupplyPhamacyObj['nphiesDaysSupply']
                            }

                            if (xc) {
                                console.log('xc', xc)
                                let sequenceVal = this.priAuthJson['entry'][1].resource['supportingInfo'].filter(supEle => supEle['category']['coding'][0]['code'] == 'days-supply' && supEle['valueQuantity']['value'] == xc)[0]['sequence']
                                console.log('sequenceVal', sequenceVal)
                                ItemMajorInterFaceObj.informationSequence.push(sequenceVal)
                            }
                        }
                        //------------------------------------ ----------------------------------------------------
                        if (!ItemMajorInterFaceObj.extension) {
                            ItemMajorInterFaceObj.extension = []
                        }
                        //-------------Extension[]------------- 
                        ExtensionTaxeObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-tax"
                        ExtensionTaxeObj.valueMoney = <valueMoneyInterFace>{}
                        ExtensionTaxeObj.valueMoney.value = ele.nphiesExtensionTaxValue
                        ExtensionTaxeObj.valueMoney.currency = "SAR"
                        ItemMajorInterFaceObj.extension.push(ExtensionTaxeObj)
                        //----------------------------------------------------
                        ExtensionPatientShareObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-patient-share"
                        ExtensionPatientShareObj.valueMoney = <valueMoneyInterFace>{}
                        ExtensionPatientShareObj.valueMoney.value = ele.nphiesExtensionPatientShareValue
                        ExtensionPatientShareObj.valueMoney.currency = "SAR"
                        ItemMajorInterFaceObj.extension.push(ExtensionPatientShareObj)
                        //----------------------------------------------------
                        if (ele.patientInvoice != null || undefined) {
                            ExtensionPatientInvoiceObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-patientInvoice"
                            ExtensionPatientInvoiceObj.valueIdentifier = <valueIdentifierInterFace>{}
                            ExtensionPatientInvoiceObj.valueIdentifier.system = "http://sgh.sa.com/patientInvoice"
                            ExtensionPatientInvoiceObj.valueIdentifier.value = ele.patientInvoice
                            ItemMajorInterFaceObj.extension.push(ExtensionPatientInvoiceObj)
                        }
                        //----------------------------------------------------
                        ExtensionPackageObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-package"
                        ExtensionPackageObj.valueBoolean = ele.nphiesExtensionpackageValue
                        ItemMajorInterFaceObj.extension.push(ExtensionPackageObj)
                        //----------------------------------------------------
                        ExtensionMaternityObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-maternity"
                        ExtensionMaternityObj.valueBoolean = ele.nphiesIsMaternity
                        ItemMajorInterFaceObj.extension.push(ExtensionMaternityObj)
                        //----------------------------------------------------
                        if ((ele.nphiesPharmacistSelectionReason != null || ele.nphiesPharmacistSelectionReason != undefined) && KeyVal['supType'] == 'pharmacy') {
                            ExtensionPharmacistSelectionReasonObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-pharmacist-Selection-Reason"
                            ExtensionPharmacistSelectionReasonObj.valueCodeableConcept = <categoryInterFace>{}
                            ExtensionPharmacistSelectionReasonObj.valueCodeableConcept.coding = []
                            let ExtensionPharmacistSelectionReasonCodingObj = <codingInterface>{}
                            ExtensionPharmacistSelectionReasonCodingObj.system = "http://nphies.sa/terminology/CodeSystem/pharmacist-selection-reason"
                            ExtensionPharmacistSelectionReasonCodingObj.code = ele.nphiesPharmacistSelectionReason
                            ExtensionPharmacistSelectionReasonCodingObj.display = ele.nphiesPharmacistSelectionReason
                            ExtensionPharmacistSelectionReasonObj.valueCodeableConcept.coding.push(ExtensionPharmacistSelectionReasonCodingObj)
                            ItemMajorInterFaceObj.extension.push(ExtensionPharmacistSelectionReasonObj)
                        }
                        //-------------------------------------
                        //------------------------------------- 
                        //  supporting info مع ال item عشان اربط كل 
                        // if (KeyVal['vitalsData'] && KeyVal['vitalsData'].length > 0) {
                        //     ItemMajorInterFaceObj.informationSequence = []
                        //     KeyVal['vitalsData'].forEach(vitalEle => {
                        //         if (vitalEle['itemsequenceno'] == ele['serviceId']) {
                        //             ItemMajorInterFaceObj.informationSequence.push(vitalEle['vitalSequance'])
                        //         }
                        //     });
                        //     console.log('ItemMajorInterFaceObj.informationSequence__', ItemMajorInterFaceObj.informationSequence)
                        // }  ///// commented for now untile connect supporting info with item in database
                        ////// Depend for now on BLOCK_OF_CODE_NO_1

                        //------------------------------------- 
                        //------------------------------------- 
                        ItemMajorInterFaceObj.sequence = ele.approvalRequestSerial
                        ItemMajorInterFaceObj.careTeamSequence = this.priAuthJson['entry'][1].resource['item'][0]['careTeamSequence']
                        if (diagnosesSquanceList.length > 0) {
                            ItemMajorInterFaceObj.diagnosisSequence = [];
                            if (KeyVal['DiagwithDaysSupplyPhamacyList'] && KeyVal['DiagwithDaysSupplyPhamacyList'].length > 0 && KeyVal['supType'] == 'pharmacy') {
                                let DiagwithDaysSupplyPhamacyObj = KeyVal['DiagwithDaysSupplyPhamacyList'].find(diagEle => diagEle['codeHyphanated'] == ele['codeHyphanated'])
                                if (DiagwithDaysSupplyPhamacyObj) {
                                    ItemMajorInterFaceObj.diagnosisSequence.push(DiagwithDaysSupplyPhamacyObj['diagnosisSerial'])
                                }
                            }
                            else {
                                ItemMajorInterFaceObj.diagnosisSequence = this.diagnosisSequensList
                            }
                        }

                        CodingObj.system = ele['display']
                        CodingObj.code = ele['codeHyphanated']
                        CodingObj.display = ele['shortDescription']

                        ItemMajorInterFaceObj.productOrService.coding.push(CodingObj)
                        // if (ele['shortDescription'] == 'UNLISTED CODE') {
                        //     let CodingObjCopy = Object.assign({}, CodingObj)
                        //     CodingObjCopy.system = "http://sgh.sa.com/medication-codes"
                        //     CodingObjCopy.code = ele['code']
                        //     CodingObjCopy.display = ele['nameEn']
                        //     ItemMajorInterFaceObj.productOrService.coding.push(CodingObjCopy)
                        // }
                        if (ele['code'] && ele['nameEn']) {   ////  'UNLISTED CODE' //// BillingShadow 
                            let CodingObjCopy = Object.assign({}, CodingObj)
                            CodingObjCopy.system = "http://sgh.com.sa/product-or-service"
                            CodingObjCopy.code = ele['code']
                            CodingObjCopy.display = ele['nameEn']
                            ItemMajorInterFaceObj.productOrService.coding.push(CodingObjCopy)
                        }
                        ItemMajorInterFaceObj.productOrService.text = ele.nameEn
                        // //----------------------------------
                        ItemMajorInterFaceObj.servicedDate = this.datepipe.transform(ele.reqDate, 'yyyy-MM-dd')
                        ItemMajorInterFaceObj.quantity.value = ele.quantity
                        ItemMajorInterFaceObj.unitPrice.value = ele.price
                        ItemMajorInterFaceObj.unitPrice.currency = "SAR"

                        // ItemMajorInterFaceObj.net['value'] = (((ele['price'] * ele['quantity']) * ele['factor']) + tax);
                        // ItemMajorInterFaceObj.net['value'] = ItemMajorInterFaceObj.net['value'].toFixed(2)
                        ItemMajorInterFaceObj.net['value'] = ele['net']
                        ItemMajorInterFaceObj.net.currency = "SAR"
                        ItemMajorInterFaceObj.factor = ele['factor']
                        TotalNet = TotalNet + (ele['net']);
                        //-----------------------------------//
                        if (KeyVal.itemsBodySites) {
                            itemsBodySitesArrCopy = [...KeyVal.itemsBodySites]
                        }
                        //------------------------------------------------------------
                        let serviceItemBodySites = []
                        serviceItemBodySites = itemsBodySitesArrCopy.filter(bodysite => bodysite.code == ele.code)

                        // if ((ele['nphiesToothEn'] != null || undefined || '') && (ele['nphiesToothDisplay'] != null || undefined || ''))  //old condition in old way
                        if (serviceItemBodySites && serviceItemBodySites.length > 0) {
                            serviceItemBodySites.forEach(bodyStie => {
                                bodySiteObj = <CodingArr>{}

                                bodySiteObj.system = "http://nphies.sa/terminology/CodeSystem/fdi-oral-region"
                                bodySiteObj.code = bodyStie['nphiesToothEn']
                                bodySiteObj.display = bodyStie['nphiesToothDisplay']

                                ItemMajorInterFaceObj.bodySite.coding.push(bodySiteObj)
                            });

                        }
                        else {
                            delete ItemMajorInterFaceObj.bodySite
                        }
                        //-------------------------------------
                        console.log('ItemMajorInterFaceObj', ItemMajorInterFaceObj)
                        ItemMajorArr.push(ItemMajorInterFaceObj)

                        console.log('ItemMajorArr', ItemMajorArr)
                        console.log('ServNameArr', ServNameArr)

                    }

                });

                if (KeyVal['supType'] == 'pharmacy') {
                    ItemMajorArr.forEach((ele, index) => {
                        let prescribedMedicationDataObj = <any>{}
                        prescribedMedicationDataObj = KeyVal['productOrServiceList'].find(item => item.codeHyphanated == ele['productOrService']['coding'][0]['code'])
                        let extensionItemObj = <extensionItem>{}
                        let nestedvalueCodeableConceptObj = <CodingArr>{}
                        extensionItemObj.valueCodeableConcept = <categoryInterFace>{}
                        extensionItemObj.valueCodeableConcept.coding = []
                        nestedvalueCodeableConceptObj.system = prescribedMedicationDataObj.nphiesPrescribedMedicationSystem  //"http://nphies.sa/terminology/CodeSystem/medication-codes",
                            nestedvalueCodeableConceptObj.code = prescribedMedicationDataObj.nphiesPrescribedMedicationCode  //ele['productOrService']['coding'][0]['code']
                        nestedvalueCodeableConceptObj.display = prescribedMedicationDataObj.nphiesPrescribedMedicationDisplay//ele['productOrService']['coding'][0]['display']
                        extensionItemObj.url = "http://nphies.sa /fhir/ksa/nphies-fs/StructureDefinition/extension-prescribed-Medication"
                        extensionItemObj.valueCodeableConcept.coding.push(nestedvalueCodeableConceptObj)

                        ele['extension'].push(extensionItemObj)
                        console.log('extensionItemObj****', extensionItemObj)
                    });
                }


                this.priAuthJson['entry'][1].resource['item'] = []
                this.priAuthJson['entry'][1].resource['item'] = ItemMajorArr

                ///BLOCK_OF_CODE_NO_1---------------------------------------------------
                if (this.informationSequenceArr.length > 0 &&
                    this.priAuthJson['entry'][1].resource['item'] && this.priAuthJson['entry'][1].resource['item'].length > 0 && KeyVal['supType'] != 'pharmacy') {
                    if (this.priAuthJson['entry'][1].resource['item'][0]['informationSequence'] &&
                        this.priAuthJson['entry'][1].resource['item'][0]['informationSequence'].length > 0) {

                        this.priAuthJson['entry'][1].resource['item'][0]['informationSequence'] = [...this.informationSequenceArr, ...this.priAuthJson['entry'][1].resource['item'][0]['informationSequence']]
                    }
                    else {
                        this.priAuthJson['entry'][1].resource['item'][0]['informationSequence'] = this.informationSequenceArr
                    }
                }
                //---------------------------------------------------------------------
                this.priAuthJson['entry'][1].resource['total']['value'] = TotalNet.toFixed(2)
                this.priAuthJson['entry'][1].resource['total']['currency'] = "SAR"
            }
        }
        if (keyName == "priority") {
            if (KeyVal) {
                this.priAuthJson['entry'][1].resource['priority']['coding'][0]['code'] = KeyVal
            }
        }
        if (keyName == "nphiesrelatedClaimObj") {
            if (KeyVal.nphiesrelatedClaimRelationship && KeyVal.nphiesRelatedClaimID) {
                this.priAuthJson['entry'][1].resource['related'][0]['relationship']['coding'][0]['code'] = KeyVal.nphiesrelatedClaimRelationship
                this.priAuthJson['entry'][1].resource['related'][0]['claim']['identifier']['value'] = KeyVal.nphiesRelatedClaimID
            }

            else {
                delete this.priAuthJson['entry'][1].resource['related']
            }
        }
        if (keyName == "relationship") {
            if (KeyVal) {
                this.priAuthJson['entry'][5].resource['relationship']['coding'][0]['code'] = KeyVal
                this.priAuthJson['entry'][5].resource['relationship']['coding'][0]['display'] = KeyVal
            }
        }
        if (keyName == "Practionerlicense") {
            if (KeyVal) {
                this.priAuthJson['entry'][6].resource['identifier'][0]['value'] = KeyVal
                this.priAuthJson['entry'][7].resource['prescriber']['identifier']['value'] = KeyVal
                this.priAuthJson['entry'][11].resource['practitioner']['identifier']['value'] = KeyVal
            }
        }
        if (keyName == "PractionerRole") {
            if (KeyVal) {
                this.priAuthJson['entry'][11].resource['id']  = KeyVal.practionerRoleGuid
                this.priAuthJson['entry'][11].fullUrl = `http://sgh.com.sa/PractitionerRole/${KeyVal.practionerRoleGuid}`
                this.priAuthJson['entry'][1].resource['careTeam'][1]['provider']['reference'] = `http://sgh.com.sa/PractitionerRole/${KeyVal.practionerRoleGuid}`
                this.priAuthJson['entry'][11].resource['code'][0]['coding'][0]['code']  = KeyVal.nphiesPractitionerRoleCode
                this.priAuthJson['entry'][11].resource['code'][0]['coding'][0]['display']  = KeyVal.nphiesPractitionerRoleDisplay
                this.priAuthJson['entry'][11].resource['code'][0]['text']  = KeyVal.nphiesPractitionerRoleDisplay
            
            }
        }

        if (keyName == "qualification") {
            if (KeyVal) {
                this.priAuthJson['entry'][1].resource['careTeam'][0]['qualification']['coding'][0]['code'] = KeyVal.nphiesSpecialtyAr;
                this.priAuthJson['entry'][1].resource['careTeam'][1]['qualification']['coding'][0]['code'] = KeyVal.nphiesSpecialtyAr;
                this.priAuthJson['entry'][1].resource['careTeam'][0]['qualification']['coding'][0]['display'] = KeyVal.nphiesSpecialtyDisplay;
                this.priAuthJson['entry'][1].resource['careTeam'][1]['qualification']['coding'][0]['display'] = KeyVal.nphiesSpecialtyDisplay;
                this.priAuthJson['entry'][1].resource['careTeam'][0]['qualification']['text']= KeyVal.nphiesSpecialtyDisplay;
                this.priAuthJson['entry'][1].resource['careTeam'][1]['qualification']['text']= KeyVal.nphiesSpecialtyDisplay;
                this.priAuthJson['entry'][11].resource['specialty'][0]['coding'][0]['code'] = KeyVal.nphiesSpecialtyAr;
                this.priAuthJson['entry'][11].resource['specialty'][0]['coding'][0]['display'] = KeyVal.nphiesSpecialtyDisplay;
                this.priAuthJson['entry'][11].resource['specialty'][0]['text']= KeyVal.nphiesSpecialtyDisplay;
            }
        }
        if (keyName == "NphiesProvID") {
            if (KeyVal) {
                this.priAuthJson['entry'][2].fullUrl = `http://sgh.com.sa/Organization/${KeyVal.nphiesProvID}`
                this.priAuthJson['entry'][2].resource['id'] = KeyVal.nphiesProvID
                this.priAuthJson['entry'][2].resource['name'] = KeyVal.provName
                this.priAuthJson['entry'][2].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.nphiesProviderTypeCode
                this.priAuthJson['entry'][2].resource['extension'][0]['valueCodeableConcept']['coding'][0]['display'] = KeyVal.nphiesProviderTypeDisplay
                this.priAuthJson['entry'][1].resource['provider']['reference'] = `http://sgh.com.sa/Organization/${KeyVal.nphiesProvID}`
                this.priAuthJson['entry'][9].resource['serviceProvider']['reference'] = `http://sgh.com.sa/Organization/${KeyVal.nphiesProvID}`
                this.priAuthJson['entry'][11].resource['organization']['reference'] = `http://sgh.com.sa/Organization/${KeyVal.nphiesProvID}`
            }
        }
        if (keyName == "SupportingInfo") {
            if (KeyVal.vitalsData) {
                let SupportingInfoTempArr = []
                //-----------------Loop on KeyVal.vitalsData Arr-----------------
                if (KeyVal.vitalsData && KeyVal.vitalsData.length > 0) {
                    SupportingInfoTempArr = this.returnVitalSignJsonAfterBind(KeyVal.vitalsData)
                }
                if (SupportingInfoTempArr.length > 0) {
                    this.priAuthJson['entry'][1].resource['supportingInfo'] = []
                    this.priAuthJson['entry'][1].resource['supportingInfo'] = SupportingInfoTempArr
                }
                //---------------------------------------------------------------
            }
        }
        if (keyName == "diagnosisList") {
            if (KeyVal) {
                this.diagnosisSequensList = []
                let diagnosisCodeableConceptOfCodingObj = <codingInterface>{}
                let diagnosisTypeCodingObj = <codingInterface>{}
                let diagnosisTypeCodingArr = <diagnosisType>{}
                let diagnosesListObj = <diagnosesList>{}
                let diagnosisListTemp = []
                diagnosesListObj.diagnosisCodeableConcept = <diagnosisCodeableConcept>{}
                diagnosesListObj.diagnosisCodeableConcept.coding = []
                diagnosisTypeCodingArr.coding = []
                let extensionOnSetItemObj = <extensionItem>{}
                let extensionOnSetvalueCodeableConceptObj = <CodingArr>{}
                extensionOnSetItemObj.valueCodeableConcept = <categoryInterFace>{}
                extensionOnSetItemObj.valueCodeableConcept.coding = []

                KeyVal.forEach((ele, index) => {
                    diagnosisCodeableConceptOfCodingObj = <codingInterface>{};
                    diagnosisTypeCodingObj = <codingInterface>{}
                    diagnosisTypeCodingArr = <diagnosisType>{}
                    diagnosesListObj = <diagnosesList>{};
                    diagnosesListObj.diagnosisCodeableConcept = <diagnosisCodeableConcept>{}
                    diagnosesListObj.diagnosisCodeableConcept.coding = []
                    diagnosisTypeCodingArr.coding = []
                    diagnosesListObj.type = [];

                    extensionOnSetItemObj = <extensionItem>{}
                    extensionOnSetvalueCodeableConceptObj = <CodingArr>{}
                    extensionOnSetItemObj.valueCodeableConcept = <categoryInterFace>{}
                    extensionOnSetItemObj.valueCodeableConcept.coding = []


                    diagnosesListObj.sequence = ele.diagnosisSerial;
                    this.diagnosisSequensList.push(ele.diagnosisSerial)

                    diagnosisCodeableConceptOfCodingObj.system = "http://hl7.org/fhir/sid/icd-10-am"
                    diagnosisCodeableConceptOfCodingObj.code = ele.code
                    if (ele.description != null || ele.description != undefined) {
                        diagnosisCodeableConceptOfCodingObj.display = ele.description
                    }

                    diagnosesListObj.diagnosisCodeableConcept.coding.push(diagnosisCodeableConceptOfCodingObj)
                    if (ele.nphiesDiagnosisTypeNameEn == 'principal') {
                        diagnosesListObj.onAdmission = Object.assign({}, this.priAuthJson['entry'][1].resource['diagnosis'][0]['onAdmission'])
                        //-----Add Extension extension-condition-onset"
                        if (ele['nphiesConditionOnset']) {
                            extensionOnSetvalueCodeableConceptObj.system = "http://nphies.sa/terminology/CodeSystem/condition-onset",
                                extensionOnSetvalueCodeableConceptObj.code = ele['nphiesConditionOnset']

                            extensionOnSetItemObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-condition-onset"
                            extensionOnSetItemObj.valueCodeableConcept.coding.push(extensionOnSetvalueCodeableConceptObj)
                            if (!diagnosesListObj.extension) {
                                diagnosesListObj.extension = []
                            }
                            diagnosesListObj.extension.push(extensionOnSetItemObj)
                        }

                    }
                    diagnosisTypeCodingObj.system = "http://nphies.sa/terminology/CodeSystem/diagnosis-type"
                    diagnosisTypeCodingObj.code = ele.nphiesDiagnosisTypeNameEn ? ele.nphiesDiagnosisTypeNameEn : 'principal'
                    diagnosisTypeCodingArr.coding.push(diagnosisTypeCodingObj)
                    diagnosesListObj.type.push(diagnosisTypeCodingArr)



                    diagnosisListTemp.push(diagnosesListObj)

                });
                this.priAuthJson['entry'][1].resource['diagnosis'] = []
                this.priAuthJson['entry'][1].resource['diagnosis'] = diagnosisListTemp
                console.log('diagnosisListTemp', diagnosisListTemp)
            }

            else {
                delete this.priAuthJson['entry'][1].resource['diagnosis']
                delete this.priAuthJson['entry'][1].resource['item'][0]['diagnosisSequence']
            }


        }
        if (keyName == "extensionTransfer") {
            let extensionTransferObj = <any>{}
            if (KeyVal) {
                extensionTransferObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-transfer"
                extensionTransferObj.valueBoolean = KeyVal

                if (!this.priAuthJson['entry'][1].resource['extension']) {
                    this.priAuthJson['entry'][1].resource['extension'] = []
                }
                this.priAuthJson['entry'][1].resource['extension'].push(extensionTransferObj)
            }

        }
        if (keyName == "extensionEligibility") {
            if (KeyVal.extensionEligibilityFlag == true) {
                let extensionEligibilityReferenceObj = <any>{}
                let extensionEligibilityDateObj = <any>{}
                if (KeyVal.refrenceType == 'online' && (KeyVal.nphiesEligibilityResponseID != null || undefined) && (KeyVal.startDate != null || undefined)) {
                    if (!this.priAuthJson['entry'][1].resource['extension']) {
                        this.priAuthJson['entry'][1].resource['extension'] = []
                    }
                    extensionEligibilityReferenceObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-eligibility-online-reference",
                        extensionEligibilityReferenceObj.valueString = KeyVal.nphiesEligibilityResponseID
                    this.priAuthJson['entry'][1].resource['extension'].push(extensionEligibilityReferenceObj)

                    extensionEligibilityDateObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-eligibility-online-date"
                    extensionEligibilityDateObj.valueDateTime = this.datepipe.transform(KeyVal.startDate, 'yyyy-MM-dd')


                    this.priAuthJson['entry'][1].resource['extension'].push(extensionEligibilityDateObj)
                }

                if (KeyVal.refrenceType == 'offline' && (KeyVal.nphiesEligibilityResponseID != null || undefined) && (KeyVal.startDate != null || undefined)) {
                    if (!this.priAuthJson['entry'][1].resource['extension']) {
                        this.priAuthJson['entry'][1].resource['extension'] = []
                    }
                    extensionEligibilityReferenceObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-eligibility-offline-reference",
                        extensionEligibilityReferenceObj.valueString = KeyVal.nphiesEligibilityResponseID

                    this.priAuthJson['entry'][1].resource['extension'].push(extensionEligibilityReferenceObj)

                    extensionEligibilityDateObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-eligibility-offline-date"
                    extensionEligibilityDateObj.valueDateTime = this.datepipe.transform(KeyVal.startDate, 'yyyy-MM-dd')

                    this.priAuthJson['entry'][1].resource['extension'].push(extensionEligibilityDateObj)
                }
            }
        }
        if (keyName == 'ExtensionEligibilityResponse') {
            if (KeyVal && KeyVal.extensionEligibilityResponse == true) {
                let extensionEligibilityResponseObj = <any>{}
                let extensionEligibilityResponsevalueReferenceResponse = <any>{}
                let extensionEligibilityResponseidentifier = <any>{}
                extensionEligibilityResponseObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-eligibility-response"

                extensionEligibilityResponseidentifier.system = KeyVal.nphiesEligibilityResponseIdentifierSystem
                extensionEligibilityResponseidentifier.value = KeyVal.nphiesEligibilityResponseID

                extensionEligibilityResponsevalueReferenceResponse.identifier = extensionEligibilityResponseidentifier
                extensionEligibilityResponseObj.valueReference = extensionEligibilityResponsevalueReferenceResponse

                if (!this.priAuthJson['entry'][1].resource['extension']) {
                    this.priAuthJson['entry'][1].resource['extension'] = []
                }
                this.priAuthJson['entry'][1].resource['extension'].push(extensionEligibilityResponseObj)
            }
        }
        if (keyName == 'ExtensionNewBorn') {
            let extensionNewBornObj = <any>{}
            if (KeyVal == 1) {
                extensionNewBornObj.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-newborn"
                extensionNewBornObj.valueBoolean = true

                if (!this.priAuthJson['entry'][1].resource['extension']) {
                    this.priAuthJson['entry'][1].resource['extension'] = []
                }
                this.priAuthJson['entry'][1].resource['extension'].push(extensionNewBornObj)
            }
        }
        if (keyName == 'extensionEncounter') {
            let extensionEncounterMajorOBJ = <any>{}
            let extensionEncounterOBJvalueReference = <any>{}
            let currentDate = new Date()

            if (KeyVal.extensionEncounterFlag == true) {
                this.priAuthJson['entry'][9].fullUrl = `http://sgh.com.sa/Encounter/${KeyVal.extensionEncounterId}`
                this.priAuthJson['entry'][9].resource['id'] = KeyVal.extensionEncounterId
                this.priAuthJson['entry'][9].resource['identifier'][0]['value'] = KeyVal.extensionEncounterVisitSerial ? KeyVal.extensionEncounterVisitSerial.toString() : null

                if (KeyVal.supType == 'institutional' && KeyVal.supSupType == 'ip') {
                    if (!this.priAuthJson['entry'][9].resource['hospitalization']['origin']) {
                        this.priAuthJson['entry'][9].resource['hospitalization']['origin'] = {}
                    }
                    this.priAuthJson['entry'][9].resource['hospitalization']['origin']['reference'] = `http://sgh.com.sa/Organization/${KeyVal.nphiesPayerlicense}`
                    this.priAuthJson['entry'][9].resource['hospitalization']['admitSource']['coding'][0]['code'] = KeyVal.nphiesEncounterAdmitSource
                    this.priAuthJson['entry'][9].resource['hospitalization']['admitSource']['coding'][0]['display'] = KeyVal.nphiesEncounterAdmitSource
                    this.priAuthJson['entry'][9].resource['hospitalization']['dischargeDisposition']['coding'][0]['code'] = KeyVal.dischargeDisposition
                    this.priAuthJson['entry'][9].resource['hospitalization']['dischargeDisposition']['coding'][0]['display'] = KeyVal.dischargeDispositionDisplay
                    this.priAuthJson['entry'][9].resource['hospitalization']['reAdmission']['coding'][0]['code'] = KeyVal.hospitalizationReAdmission
                }

                if (
                    (KeyVal.supType == 'professional' && (KeyVal.supSupType == 'op' || KeyVal.supSupType == 'emr')) ||
                    (KeyVal.supType == 'oral' && KeyVal.supSupType == 'op') ||
                    (KeyVal.supType == 'institutional' && KeyVal.supSupType == 'ip')
                ) {
                    this.priAuthJson['entry'][9].resource['status'] = KeyVal.nphiesEncounterStatusEn
                    this.priAuthJson['entry'][9].resource['class']['code'] = KeyVal.nphiesEncounterClassEn
                    this.priAuthJson['entry'][9].resource['class']['display'] = KeyVal.nphiesEncounterClassDisplay
                    this.priAuthJson['entry'][9].resource['priority']['coding'][0]['code'] = KeyVal.nphiesActPriority
                    this.priAuthJson['entry'][9].resource['serviceType']['coding'][0]['code'] = KeyVal.nphiesServiceType
                    this.priAuthJson['entry'][9].resource['period']['start'] = this.datepipe.transform(KeyVal.extensionPeriod.start, 'yyyy-MM-ddThh:mm:ss.00+03:00')
                    if (KeyVal.extensionPeriod.end) {
                        this.priAuthJson['entry'][9].resource['period']['end'] = this.datepipe.transform(KeyVal.extensionPeriod.end, 'yyyy-MM-ddThh:mm:ss.00+03:00')
                    }
                }


                KeyVal.extensionArrData.forEach(ele => {
                    if (ele.code || ele.valueDateTime) {
                        let extensionObj = <any>{}
                        let nestedvalueCodeableConceptObj = <CodingArr>{}

                        nestedvalueCodeableConceptObj.system = ele.system
                        nestedvalueCodeableConceptObj.code = ele.code
                        nestedvalueCodeableConceptObj.display = ele.display

                        if (ele.valueDateTime) {
                            extensionObj.valueDateTime = this.datepipe.transform(ele.valueDateTime, 'yyyy-MM-ddThh:mm:ss.00+03:00')
                            extensionObj.url = ele.url
                        }

                        if (nestedvalueCodeableConceptObj && nestedvalueCodeableConceptObj.code) {
                            extensionObj.valueCodeableConcept = <categoryInterFace>{}
                            extensionObj.valueCodeableConcept.coding = []
                            extensionObj.valueCodeableConcept.coding.push(nestedvalueCodeableConceptObj)
                            extensionObj.url = ele.url
                        }

                        if ((ele.name == 'serviceEventType' && !(KeyVal.supType == 'institutional' && KeyVal.supSupType == 'ip')
                        ) ||
                            (ele.name == 'causeOfDeath' && (KeyVal.supType == 'institutional' && KeyVal.supSupType == 'ip'))
                        ) {
                            if (!this.priAuthJson['entry'][9].resource['extension']) {
                                this.priAuthJson['entry'][9].resource['extension'] = []
                            }
                            this.priAuthJson['entry'][9].resource['extension'].push(extensionObj)
                        }
                        else {
                            if (
                                ((ele.name == 'emergencyArrivalCode' || ele.name == 'emergencyServiceStart' || ele.name == 'emergencyDepartmentDisposition' || ele.name == 'triageCategory' || ele.name == 'triageDate')
                                    && (KeyVal.supType == 'professional' && KeyVal.supSupType == 'emr')
                                )
                                ||
                                ((ele.name == 'intendedLengthOfStay' || ele.name == 'admissionSpecialty' || ele.name == 'dischargeSpecialty')
                                    && (KeyVal.supType == 'institutional' && KeyVal.supSupType == 'ip')
                                )

                            ) {
                                if (!this.priAuthJson['entry'][9].resource['hospitalization']['extension']) {
                                    this.priAuthJson['entry'][9].resource['hospitalization']['extension'] = []
                                }
                                this.priAuthJson['entry'][9].resource['hospitalization']['extension'].push(extensionObj)
                            }
                        }

                    }
                });


                //--------------------------Add extensionEncounter in "resourceType": "Claim"---------------------//
                extensionEncounterMajorOBJ.url = "http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/extension-encounter"
                extensionEncounterOBJvalueReference.reference = `Encounter/${KeyVal.extensionEncounterId}`
                extensionEncounterMajorOBJ.valueReference = extensionEncounterOBJvalueReference

                if (!this.priAuthJson['entry'][1].resource['extension']) {
                    this.priAuthJson['entry'][1].resource['extension'] = []
                }
                this.priAuthJson['entry'][1].resource['extension'].push(extensionEncounterMajorOBJ)
                //------------------------------------------------------------------------------------------------//
            }
            else {
                this.priAuthJson['entry'][9]['SpliceFromEntryFlag'] = true
            }
        }
        if (keyName == 'referral') {
            if (KeyVal.nphiesEligibilityTransferReference) {
                if (!this.priAuthJson['entry'][1].resource['referral']) {
                    this.priAuthJson['entry'][1].resource['referral'] = <any>{}
                    this.priAuthJson['entry'][1].resource['referral']['display'] = KeyVal.nphiesEligibilityTransferReference
                }
                if (!this.priAuthJson['entry'][1].resource['insurance'][0]['preAuthRef']) {
                    this.priAuthJson['entry'][1].resource['insurance'][0]['preAuthRef'] = []

                    this.priAuthJson['entry'][1].resource['insurance'][0]['preAuthRef'].push(KeyVal.nphiesPreAuthRef)
                }
            }
        }
        if (keyName == 'visionprescriptionData') {
            if (KeyVal.ucafTempleteData['emrpatGlassCardList'] && KeyVal.ucafTempleteData['emrpatGlassCardList'].length > 0) {
                this.priAuthJson['entry'][7].fullUrl = `http://sgh.com.sa/Visionprescription/${KeyVal.guid}`
                this.priAuthJson['entry'][7].resource['id'] = KeyVal.guid
                this.priAuthJson['entry'][7].resource['identifier'][0]['value'] = KeyVal.guid

                this.priAuthJson['entry'][1].resource['prescription']['reference'] = `http://sgh.com.sa/Visionprescription/${KeyVal.guid}`

                this.priAuthJson['entry'][7].resource['created'] = this.datepipe.transform(KeyVal.reqDate, 'yyyy-MM-dd')
                this.priAuthJson['entry'][7].resource['dateWritten'] = this.datepipe.transform(KeyVal.reqDate, 'yyyy-MM-dd')
                this.priAuthJson['entry'][7].resource['lensSpecification'][0]['sphere'] = KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['sphereleft']
                this.priAuthJson['entry'][7].resource['lensSpecification'][0]['cylinder'] = KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['cylinderleft']
                this.priAuthJson['entry'][7].resource['lensSpecification'][0]['axis'] = KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['axisleft']

                this.priAuthJson['entry'][7].resource['lensSpecification'][1]['sphere'] = KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['sphereRight']
                this.priAuthJson['entry'][7].resource['lensSpecification'][1]['cylinder'] = KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['cylindeRight']
                this.priAuthJson['entry'][7].resource['lensSpecification'][1]['axis'] = KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['axisRight']

                if (!KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['sphereRight'] &&
                    !KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['cylindeRight'] &&
                    !KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['axisRight']) {
                    this.priAuthJson['entry'][7].resource['lensSpecification'].splice(1)
                }
                if (!KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['sphereleft'] &&
                    !KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['cylinderleft'] &&
                    !KeyVal.ucafTempleteData['emrpatGlassCardList'][0]['axisleft']) {
                    this.priAuthJson['entry'][7].resource['lensSpecification'].splice(0)
                }
            }

            else {
                delete this.priAuthJson['entry'][7].resource['lensSpecification']
            }
        }
        if (keyName == "AuthorizationType") {
            let supType
            // switch (KeyVal.supType) {
            //     case 'institutional':
            //         supType = 'ip'
            //         break;

            //     case 'professional':
            //         supType = 'op'
            //         break;

            //     case 'oral':
            //         supType = 'op'
            //         break;

            //     case 'pharmacy':
            //         supType = 'op'
            //         break;

            //     case 'vision':
            //         supType = 'op'
            //         break;
            //     default:
            //         supType = 'ip'
            //         break;

            // }
            supType = KeyVal.supSupType
            this.priAuthJson['entry'][1].resource['type']['coding'][0]['code'] = KeyVal.supType
            this.priAuthJson['entry'][1].resource['subType']['coding'][0]['code'] = supType
            this.priAuthJson['entry'][1].resource['meta']['profile'][0] = `http://nphies.sa/fhir/ksa/nphies-fs/StructureDefinition/${KeyVal.supType}-priorauth|1.0.0`

            if (KeyVal.supType == 'professional' || KeyVal.supType == 'oral' || KeyVal.supType == 'pharmacy' || KeyVal.supType == 'vision') {
                if (this.priAuthJson['entry'][1].resource['diagnosis'] && this.priAuthJson['entry'][1].resource['diagnosis'].length > 0) {
                    this.priAuthJson['entry'][1].resource['diagnosis'].forEach(diagEle => {
                        if (diagEle && diagEle['onAdmission']) {
                            delete diagEle['onAdmission']
                        }

                        if (diagEle && diagEle['extension']) {
                            delete diagEle['extension']  //// For Delete extension onSet   the only one in extension  array
                        }
                    });
                }


            }
            if (KeyVal.supType == 'pharmacy') {
                delete this.priAuthJson['entry'][1].resource['careTeam']
                if (this.priAuthJson['entry'][1].resource['item'].length > 0) {
                    this.priAuthJson['entry'][1].resource['item'].forEach(ele => {
                        delete ele.careTeamSequence
                    });
                }
                //__________________________________________________________________________________
                this.priAuthJson['entry'][6]['SpliceFromEntryFlag'] = true
                this.priAuthJson['entry'][11]['SpliceFromEntryFlag'] = true
            }

            if (KeyVal.supType != 'pharmacy') {
                //_________________Delete "days-supply" OBJ from Supporting info____________________
                if (this.priAuthJson['entry'][1].resource['supportingInfo'] && this.priAuthJson['entry'][1].resource['supportingInfo'].length > 0) {
                    this.priAuthJson['entry'][1].resource['supportingInfo'] = this.priAuthJson['entry'][1].resource['supportingInfo'].filter(ele => ele.category.coding[0]['code'] != 'days-supply')
                }
                // this.priAuthJson['entry'][1].resource['item'].forEach(ele => {
                //     ele['extension'].splice(3, 2)
                // });
            }

            if (KeyVal.supType != 'vision') {
                delete this.priAuthJson['entry'][1].resource['prescription'];
                this.priAuthJson['entry'][7]['SpliceFromEntryFlag'] = true
            }

            // if (KeyVal.supType == 'institutional') {

            //     this.priAuthJson['entry'][1].resource['item'].forEach(ele => {
            //         ele['extension'][0]['valueBoolean'] = true
            //     });
            // } 
            // دا ليه معمول كدا انا بالفعل راسمه ال extension 
            // بالقيم بتاعته فوق


            if (KeyVal.parentdataCode == null || undefined) {
                this.priAuthJson['entry'][8]['SpliceFromEntryFlag'] = true
            }


            this.priAuthJson['entry'] = this.priAuthJson['entry'].filter(ele => !ele['SpliceFromEntryFlag'])
            console.log('priAuthJsonloop', this.priAuthJson)

        }
    }

    //-------------------------------------Poll-------------------------------------
    setPollRequestJson(pollData) {
        let currentDate = new Date()
        let date = new Date()
        this.getTimeStamp('timestamp', this.datepipe.transform(date, 'yyyy-MM-ddThh:mm:ss.00+02:00'), this.pollJson)
        this.getRandomId('bundelId', pollData['guid'], this.pollJson)
        this.replacePoll('messageHeaderId', pollData['guid'])
        this.replacePoll('TaskId', pollData['guid'])
        this.replacePoll('PollType', pollData['PollType'])
        this.replacePoll('nphiesPollValueCode', pollData['nphiesPollValueCode'])
        this.replacePoll('nphiesPollTaskInputType', pollData['nphiesPollTaskInputType'])
        this.replacePoll('nphiesPollTaskStatus', pollData['nphiesPollTaskStatus'])
        this.replacePoll('nphiesPollRequestIntent', pollData['nphiesPollRequestIntent'])
        this.replacePoll('priority', pollData.priority)
        this.replacePoll('providerLicense', pollData.nphiesProviderlicense)
        this.replacePoll('PollPeriod', {
            start: this.datepipe.transform(pollData.pollPeriodFrom, 'yyyy-MM-dd')
            , end: this.datepipe.transform(pollData.pollPeriodTo, 'yyyy-MM-dd')
        })
        this.datepipe.transform(getDateObj(currentDate), 'yyyy-MM-dd')
        this.replacePoll('currentDate', {
            start: this.datepipe.transform(getDateObj(currentDate), 'yyyy-MM-dd'),
            end: this.datepipe.transform(getDateObj(currentDate), 'yyyy-MM-dd')
        })
        this.replacePoll('provider', { providerId: pollData.nphiesProvID, providerName: pollData.provName, nphiesProviderTypeCode: pollData.nphiesProviderTypeCode, nphiesProviderTypeDisplay: pollData.nphiesProviderTypeDisplay })
        //-----------------Poll Req Log -------------------
        return this.returnBackEndProperties(pollData, 'PollRequest', this.pollJson, 'http://pr-fhir.com.sa')
        //--------------------------------------------------
    }
    replacePoll(keyName, KeyVal) {
        if (keyName == "messageHeaderId") {
            this.pollJson['entry'][0].resource['id'] = KeyVal
            this.pollJson['entry'][0].fullUrl = `urn:uuid:${KeyVal}`
        }

        if (keyName == "TaskId") {
            this.pollJson['entry'][0].resource['focus'][0]['reference'] = `http://pr-fhir.com.sa/Task/${KeyVal}`
            this.pollJson['entry'][1].fullUrl = `http://pr-fhir.com.sa/Task/${KeyVal}`
            this.pollJson['entry'][1].resource['id'] = KeyVal
            this.pollJson['entry'][1].resource['identifier'][0]['value'] = KeyVal
            this.pollJson['entry'][1].resource['identifier'][0]['system'] = `http://pr-fhir.com.sa/Task`
        }

        if (keyName == "PollType") {
            this.pollJson['entry'][1].resource['input'][0]['valueCode'] = KeyVal
        }

        if (keyName == "nphiesPollValueCode") {
            this.pollJson['entry'][1].resource['input'][0]['valueCode'] = KeyVal
        }

        if (keyName == "nphiesPollTaskInputType") {
            if (KeyVal) {
                this.pollJson['entry'][1].resource['input'][0]['type']['coding'][0]['code'] = KeyVal
            }
        }
        if (keyName == "nphiesPollTaskStatus") {
            if (KeyVal) {
                this.pollJson['entry'][1].resource['status'] = KeyVal
            }
        }
        if (keyName == "nphiesPollRequestIntent") {
            if (KeyVal) {
                this.pollJson['entry'][1].resource['intent'] = KeyVal
            }
        }
        if (keyName == "priority") {
            if (KeyVal) {
                this.pollJson['entry'][1].resource['priority'] = KeyVal
            }
        }

        if (keyName == "provider") {
            this.pollJson['entry'][2].fullUrl = `http://pr-fhir.com.sa/Organization/${KeyVal.providerId}`
            this.pollJson['entry'][2].resource['id'] = KeyVal.providerId
            this.pollJson['entry'][2].resource['name'] = KeyVal.providerName
            this.pollJson['entry'][1].resource['requester']['reference'] = `http://pr-fhir.com.sa/Organization/${KeyVal.providerId}`
            this.pollJson['entry'][2].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.nphiesProviderTypeCode
            this.pollJson['entry'][2].resource['extension'][0]['valueCodeableConcept']['coding'][0]['display'] = KeyVal.nphiesProviderTypeDisplay
        }
        if (keyName == "providerLicense") {

            this.pollJson['entry'][0].resource['sender']['identifier']['value'] = KeyVal
            this.pollJson['entry'][0].resource['source']['endpoint'] = `http://nphies.sa/license/provider-license/${KeyVal}`
            this.pollJson['entry'][2].resource['identifier'][0]['value'] = KeyVal
        }
        if (keyName == "currentDate") {
            this.pollJson['entry'][1].resource['authoredOn'] = KeyVal.start
            this.pollJson['entry'][1].resource['lastModified'] = KeyVal.end
        }



    }
    //-----------------------------------Cancel Request----------------------------
    setCancelRequestJson(cancelData) {
        this.setFormSettings('fhirCancelReq');
        let currentDate = new Date()
        let dateTime = new Date()
        this.getTimeStamp('timestamp', this.datepipe.transform(dateTime, 'yyyy-MM-ddThh:mm:ss.00+02:00'), this.cancelJson)
        this.getRandomId('bundelId', cancelData['guid'], this.cancelJson)
        this.replaceCancelRequest('bundelId', cancelData['guid'])
        this.replaceCancelRequest('messageHeaderId', cancelData['guid'])
        this.replaceCancelRequest('TaskId', cancelData['guid'])
        this.replaceCancelRequest('CancelType', cancelData['cancelType'])
        this.replaceCancelRequest('ReasonCode', cancelData['reasonCode'])
        this.replaceCancelRequest('ClaimID', cancelData['nphiesClaimID'])
        this.replaceCancelRequest('nphiesPollTaskStatus', cancelData['nphiesPollTaskStatus'])
        this.replaceCancelRequest('nphiesPollRequestIntent', cancelData['nphiesPollRequestIntent'])
        this.replaceCancelRequest('priority', cancelData.priority)
        this.replaceCancelRequest('currentDate', {
            start: this.datepipe.transform(getDateObj(currentDate), 'yyyy-MM-dd'),
            end: this.datepipe.transform(getDateObj(currentDate), 'yyyy-MM-dd')
        })
        this.replaceCancelRequest('Insurer', { insurerID: cancelData.tpaNphiesID, insurerName: cancelData.tpaNphiesNameEn })
        this.replaceCancelRequest('provider', { providerId: cancelData.nphiesProvID, providerName: cancelData.provName, nphiesProviderTypeCode: cancelData.nphiesProviderTypeCode, nphiesProviderTypeDisplay: cancelData.nphiesProviderTypeDisplay })
        this.replaceCancelRequest('providerLicense', cancelData.nphiesProviderlicense)
        this.replaceCancelRequest('payorLicense', cancelData.nphiesPayerlicense)
        this.replaceCancelRequest('endPoint', cancelData.naphiesReplacedUrl)
        this.replaceCancelRequest('CancelAdvancedAuthorization', cancelData.advancedAuthorizationFlag)
        //-----------------Cancel Req Log -------------------
        return this.returnBackEndProperties(cancelData, 'CancelRequest', this.cancelJson, 'http://sni.com.sa')
    }
    replaceCancelRequest(keyName, KeyVal) {
        if (keyName == "messageHeaderId") {
            this.cancelJson['entry'][0].resource['id'] = KeyVal
            this.cancelJson['entry'][0].fullUrl = `urn:uuid:${KeyVal}`
        }

        if (keyName == "TaskId") {
            this.cancelJson['entry'][0].resource['focus'][0]['reference'] = `http://sni.com.sa/Task/${KeyVal}`
            this.cancelJson['entry'][1].fullUrl = `http://sni.com.sa/Task/${KeyVal}`
            this.cancelJson['entry'][1].resource['id'] = KeyVal
            this.cancelJson['entry'][1].resource['identifier'][0]['value'] = KeyVal
        }

        if (keyName == "CancelType") {
            if (KeyVal) {
                this.cancelJson['entry'][1].resource['focus']['identifier']['system'] = `http://sni.com.sa/${KeyVal}`
            }
        }

        if (keyName == "nphiesPollTaskStatus") {
            if (KeyVal) {
                this.cancelJson['entry'][1].resource['status'] = KeyVal
            }
        }
        if (keyName == "nphiesPollRequestIntent") {
            if (KeyVal) {
                this.cancelJson['entry'][1].resource['intent'] = KeyVal
            }
        }
        if (keyName == "priority") {
            if (KeyVal) {
                this.cancelJson['entry'][1].resource['priority'] = KeyVal
            }
        }

        if (keyName == "ReasonCode") {
            if (KeyVal) {
                this.cancelJson['entry'][1].resource['reasonCode']['coding'][0]['code'] = KeyVal
            }
        }

        if (keyName == "ClaimID") {
            this.cancelJson['entry'][1].resource['focus']['identifier']['value'] = KeyVal
        }


        if (keyName == "currentDate") {
            this.cancelJson['entry'][1].resource['authoredOn'] = KeyVal.start
            this.cancelJson['entry'][1].resource['lastModified'] = KeyVal.end
        }

        if (keyName == "endPoint") {
            this.cancelJson['entry'][0].resource['source']['endpoint'] = KeyVal
        }

        if (keyName == "provider") {
            this.cancelJson['entry'][2].fullUrl = `http://sni.com.sa/Organization/${KeyVal.providerId}`
            this.cancelJson['entry'][2].resource['id'] = KeyVal.providerId
            this.cancelJson['entry'][2].resource['name'] = KeyVal.providerName;
            this.cancelJson['entry'][2].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.nphiesProviderTypeCode
            this.cancelJson['entry'][2].resource['extension'][0]['valueCodeableConcept']['coding'][0]['display'] = KeyVal.nphiesProviderTypeDisplay
            this.cancelJson['entry'][1].resource['requester']['reference'] = `http://sni.com.sa/Organization/${KeyVal.providerId}`
        }

        if (keyName == "Insurer") {
            this.cancelJson['entry'][3].resource['id'] = KeyVal.insurerID;
            this.cancelJson['entry'][3].resource['name'] = KeyVal.insurerName;
            this.cancelJson['entry'][3].fullUrl = `http://sni.com.sa/Organization/${KeyVal.insurerID}`
            this.cancelJson['entry'][1].resource['owner']['reference'] = `http://sni.com.sa/Organization/${KeyVal.insurerID}`
        }
        if (keyName == "providerLicense") {
            this.cancelJson['entry'][0].resource['sender']['identifier']['value'] = KeyVal
            this.cancelJson['entry'][2].resource['identifier'][0]['value'] = KeyVal
        }

        if (keyName == "payorLicense") {
            this.cancelJson['entry'][0].resource['destination'][0]['endpoint'] = `http://sni.com.sa/license/payer-license/${KeyVal}`
            this.cancelJson['entry'][0].resource['destination'][0]['receiver']['identifier']['value'] = KeyVal
            this.cancelJson['entry'][3].resource['identifier'][0]['value'] = KeyVal
        }

        if (keyName == "CancelAdvancedAuthorization") {
            if (KeyVal == 1) {
                this.cancelJson['entry'][1].resource['focus']['type'] = 'ClaimResponse'
                this.cancelJson['entry'][1].resource['focus']['identifier']['system'] = "http://pseudo-payer.com.sa/advanced-priorauth"
            }
        }
        delete this.cancelJson['entry'][2].resource['address']
        delete this.cancelJson['entry'][2].resource['contact']
        delete this.cancelJson['entry'][3].resource['address']
        delete this.cancelJson['entry'][3].resource['contact']
    }
    //--------------------------------Communication Request------------------------
    setCommunicationJson(communicationData, type) {
        let dateTime = new Date()
        communicationData['dateCreation'] = dateTime
        this.getTimeStamp('timestamp', this.datepipe.transform(dateTime, 'yyyy-MM-ddThh:mm:ss.00+02:00'), this.unSoloicitedCommunication)
        this.getRandomId('bundelId', communicationData.guid, this.unSoloicitedCommunication)
        this.replaceCommunicationJson('CommunicationData', communicationData, type)
        //-----------------Communication Req Log -------------------
        communicationData['nphiesAboutCommunicationClaim'] = this.unSoloicitedCommunication['entry'][1].resource['about'][0]['identifier']['value']
        // if (type == 1) {
        //     communicationData['nphiesBasedOnCommunicationRequest'] = this.unSoloicitedCommunication['entry'][1].resource['basedOn'] &&
        //         this.unSoloicitedCommunication['entry'][1].resource['basedOn'][0] ?
        //         this.unSoloicitedCommunication['entry'][1].resource['basedOn'][0]['identifier']['value'] : null
        // }
        return this.returnBackEndProperties(communicationData, 'communication', this.unSoloicitedCommunication, 'http://sni.com.sa')
        //--------------------------------------------------
    }
    replaceCommunicationJson(keyName, KeyVal, type) {
        if (keyName == "CommunicationData") {
            //--------------------messageHeaderId---------------
            this.unSoloicitedCommunication['entry'][0].resource['id'] = KeyVal.guid
            this.unSoloicitedCommunication['entry'][0].fullUrl = `urn:uuid:${KeyVal.guid}`
            //---------------------------CommunicationRequestId------
            this.unSoloicitedCommunication['entry'][1].fullUrl = `http://sni.com.sa/Communication/${KeyVal.guid}`
            this.unSoloicitedCommunication['entry'][1].resource['id'] = KeyVal.guid
            this.unSoloicitedCommunication['entry'][1].resource['identifier'][0]['value'] = KeyVal.guid
            this.unSoloicitedCommunication['entry'][0].resource['focus'][0]['reference'] = `http://sni.com.sa/Communication/${KeyVal.guid}`
            //------------------------Patient Info -----------------
            this.unSoloicitedCommunication['entry'][2]['resource']['id'] = KeyVal.patientCode
            this.unSoloicitedCommunication['entry'][2].fullUrl = `http://sni.com.sa/Patient/${KeyVal.patientCode}`
            this.unSoloicitedCommunication['entry'][1].resource['subject']['reference'] = `http://sni.com.sa/Patient/${KeyVal.patientCode}`
            this.unSoloicitedCommunication['entry'][2].resource['identifier'][0]['type']['coding'][0]['code'] = KeyVal.identityValNphiesCode
            this.unSoloicitedCommunication['entry'][2].resource['identifier'][0]['type']['coding'][0]['display'] = KeyVal.identityValNphiesDisplay
            this.unSoloicitedCommunication['entry'][2].resource['identifier'][0]['system'] = `http://nphies.sa/identifier/${KeyVal.identityValNphiesDisplay}`

            this.unSoloicitedCommunication['entry'][2].resource['identifier'][0]['value'] = KeyVal.identityValue
            this.unSoloicitedCommunication['entry'][2].resource['name'][0]['text'] = KeyVal.fullnameEn
            this.unSoloicitedCommunication['entry'][2].resource['name'][0]['family'] = KeyVal.lnameEn
            this.unSoloicitedCommunication['entry'][2].resource['name'][0]['given'] = []
            this.unSoloicitedCommunication['entry'][2].resource['name'][0]['given'] = [KeyVal.fnameEn, KeyVal.snameEn, KeyVal.lnameEn]
            this.unSoloicitedCommunication['entry'][2].resource['telecom']['value'] = `+${KeyVal.mobile}`
            this.unSoloicitedCommunication['entry'][2].resource['gender'] = KeyVal.nphiesGenderCode  ?   KeyVal.nphiesGenderCode  :  'unknown' 
            this.unSoloicitedCommunication['entry'][2].resource['_gender']['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.nphiesGenderCode  ?   KeyVal.nphiesGenderCode  :  'unknown' 
            this.unSoloicitedCommunication['entry'][2].resource['birthDate'] = this.datepipe.transform(KeyVal.birthDate, 'yyyy-MM-dd')
            this.unSoloicitedCommunication['entry'][2].resource['maritalStatus']['coding'][0]['code'] = KeyVal.maritalStatus
            this.unSoloicitedCommunication['entry'][2].resource['maritalStatus']['coding'][0]['system'] = KeyVal.maritalStatus == 'UNK' ? "http://terminology.hl7.org/CodeSystem/v3-NullFlavor" : "http://terminology.hl7.org/CodeSystem/v3-MaritalStatus"

            this.unSoloicitedCommunication['entry'][2].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.patientOccupation

            // ---------------------------Provider ---------------------------
            this.unSoloicitedCommunication['entry'][3].fullUrl = `http://sni.com.sa/Organization/${KeyVal.nphiesProvID}`
            this.unSoloicitedCommunication['entry'][3].resource['id'] = KeyVal.nphiesProvID
            this.unSoloicitedCommunication['entry'][1].resource['sender']['reference'] = `http://sni.com.sa/Organization/${KeyVal.nphiesProvID}`
            this.unSoloicitedCommunication['entry'][3].resource['name'] = KeyVal.provName;
            this.unSoloicitedCommunication['entry'][3].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.nphiesProviderTypeCode
            this.unSoloicitedCommunication['entry'][3].resource['extension'][0]['valueCodeableConcept']['coding'][0]['display'] = KeyVal.nphiesProviderTypeDisplay
            //-------------------------About Claim ----------------------
            this.unSoloicitedCommunication['entry'][1].resource['about'][0]['type'] = type == 1 && KeyVal.advancedAuthorizationFlag == 1 ? 'ClaimResponse' : 'Claim'
            this.unSoloicitedCommunication['entry'][1].resource['about'][0]['identifier']['system'] = type == 1 && KeyVal.advancedAuthorizationFlag == 1 ? KeyVal.nphiesClaimResponseIdentifierSystem : `http://sni.com.sa/${KeyVal.nphiesType}`
            this.unSoloicitedCommunication['entry'][1].resource['about'][0]['identifier']['value'] = KeyVal.nphiesClaimID
            //-------------------------Insurer ----------------------
            this.unSoloicitedCommunication['entry'][1].resource['recipient'][0]['reference'] = `http://sni.com.sa/Organization/${KeyVal.tpaNphiesID}`
            this.unSoloicitedCommunication['entry'][4].fullUrl = `http://sni.com.sa/Organization/${KeyVal.tpaNphiesID}`
            this.unSoloicitedCommunication['entry'][4].resource['id'] = KeyVal.tpaNphiesID
            this.unSoloicitedCommunication['entry'][4].resource['name'] = KeyVal.tpaNphiesNameEn;


            //-----------------------Creation Date--------------------
            //this.unSoloicitedCommunication.entry[1].resource['payload'][length-1]['contentAttachment']['creation'] = this.datepipe.transform(KeyVal.reqDate, 'yyyy-MM-dd')
            //----------------------------Provider Licence --------------------------
            this.unSoloicitedCommunication.entry[0].resource['sender']['identifier']['value'] = KeyVal.nphiesProviderlicense
            this.unSoloicitedCommunication.entry[3].resource['identifier'][0]['value'] = KeyVal.nphiesProviderlicense
            //-----------------------------Payor Licence  --------------------------
            this.unSoloicitedCommunication.entry[4].resource['identifier'][0]['value'] = KeyVal.nphiesPayerlicense
            this.unSoloicitedCommunication.entry[0].resource['destination'][0]['receiver']['identifier']['value'] = KeyVal.nphiesPayerlicense
            this.unSoloicitedCommunication.entry[0].resource['destination'][0]['endpoint'] = `http://nphies.sa/license/payer-license/${KeyVal.nphiesPayerlicense}`
            //----------------------------Source Endpoint --------------------------
            this.unSoloicitedCommunication.entry[0].resource['source']['endpoint'] = KeyVal.naphiesReplacedUrl
            //----------------------------Priority---------------------------
            this.unSoloicitedCommunication.entry[1].resource['priority'] = KeyVal.priority ? KeyVal.priority : 'stat'


        }

        if (type == 1) ///____________________type = 1 for Soliceted  Communication
        {
            this.unSoloicitedCommunication['entry'][1].resource['basedOn'] = [
                {
                    "type": "CommunicationRequest",
                    "identifier": {
                        "system": "http://tmb-ins.com.sa/CommunicationRequest",
                        "value": "174803"
                    }
                }
            ]
            this.unSoloicitedCommunication['entry'][1].resource['basedOn'][0]['identifier']['value'] = KeyVal.nphiesCommunicationRequestClaimID
            ///not needed any more/// this.unSoloicitedCommunication['entry'][1].resource['payload'][0]['contentString'] = "As per your reuqest, please find the enclosed updated lab report including HbAIC, LFT and Lipid profiles"
        }



    }
    //---------------------------------Nullify Request-----------------------------
    replaceNullifyRequest(keyName, KeyVal) {
        if (keyName == "messageHeaderId") {
            this.fhirJsonObj['entry'][0].resource['id'] = KeyVal
            this.fhirJsonObj['entry'][0].fullUrl = `urn:uuid:${KeyVal}`
        }

        if (keyName == "TaskId") {
            this.fhirJsonObj['entry'][0].resource['focus'][0]['reference'] = `http://pr-fhir.com.sa/Task/${KeyVal}`
            this.fhirJsonObj['entry'][1].fullUrl = `http://pr-fhir.com.sa/Task/${KeyVal}`
            this.fhirJsonObj['entry'][1].resource['id'] = KeyVal
            this.fhirJsonObj['entry'][1].resource['identifier'][0]['value'] = KeyVal
        }

        if (keyName == "CancelType") {
            let cancelType: string
            switch (KeyVal) {
                case 'EligibilityRequest':
                    cancelType = 'CoverageEligibilityRequest'
                    break;

                case 'AuthorizationRequest':
                    cancelType = 'Claim'
                    break;

                case 'ClaimRequest':
                    cancelType = 'Claim'
                    break;

            }
            this.fhirJsonObj['entry'][1].resource['focus']['type'] = cancelType
            this.fhirJsonObj['entry'][1].resource['focus']['identifier']['system'] = `http://happyvalley.com/${cancelType}`
        }

        if (keyName == "msgCancelId") {
            this.fhirJsonObj['entry'][1].resource['focus']['identifier']['value'] = KeyVal
        }

        if (keyName == "currentDate") {
            this.fhirJsonObj['entry'][1].resource['authoredOn'] = KeyVal.start
            this.fhirJsonObj['entry'][1].resource['lastModified'] = KeyVal.end
        }

        if (keyName == "sender") {
            let id = KeyVal.resource['id']
            let senderName = KeyVal.resource['name']
            this.fhirJsonObj['entry'][2].fullUrl = `http://pr-fhir.com.sa/Organization/${id}`
            this.fhirJsonObj['entry'][2].resource['id'] = id
            this.fhirJsonObj['entry'][2].resource['name'] = senderName;
            this.fhirJsonObj['entry'][1].resource['requester']['reference'] = `http://pr-fhir.com.sa/Organization/${id}`
        }

        if (keyName == "resciever") {
            let id = KeyVal.resource['id']
            let rescieverName = KeyVal.resource['name']
            this.fhirJsonObj['entry'][3].fullUrl = `http://pr-fhir.com.sa/Organization/${id}`
            this.fhirJsonObj['entry'][3].resource['id'] = id
            this.fhirJsonObj['entry'][3].resource['name'] = rescieverName;
            this.fhirJsonObj['entry'][1].resource['owner']['reference'] = `http://pr-fhir.com.sa/Organization/${id}`
        }

        delete this.fhirJsonObj['entry'][2].resource['address']
        delete this.fhirJsonObj['entry'][2].resource['contact']
        delete this.fhirJsonObj['entry'][3].resource['address']
        delete this.fhirJsonObj['entry'][3].resource['contact']
    }
    //---------------------------------CheckStatus Request-------------------------
    setCheckstatusRequestJson(checkStatusData) {
        this.setFormSettings('fhirCancelReq');
        let currentDate = new Date()
        let dateTime = new Date()
        this.getTimeStamp('timestamp', this.datepipe.transform(dateTime, 'yyyy-MM-ddThh:mm:ss.00+02:00'), this.checkStatusJson)
        this.getRandomId('bundelId', checkStatusData['guid'], this.checkStatusJson)
        this.replaceCheckStatusRequest('guidReplacement', checkStatusData['guid'])
        this.replaceCheckStatusRequest('CheckStatusType', checkStatusData['checkStatusType'])
        this.replaceCheckStatusRequest('ClaimID', checkStatusData['nphiesClaimID'])
        this.replaceCheckStatusRequest('TaskThreeParms', {
            nphiesPollTaskStatus: checkStatusData['nphiesPollTaskStatus'],
            nphiesPollRequestIntent: checkStatusData['nphiesPollRequestIntent'],
            priority: checkStatusData['priority']
        })

        this.replaceCheckStatusRequest('currentDate', {
            start: this.datepipe.transform(getDateObj(currentDate), 'yyyy-MM-dd'),
            end: this.datepipe.transform(getDateObj(currentDate), 'yyyy-MM-dd')
        })

        this.replaceCheckStatusRequest('Insurer', {
            insurerID: checkStatusData.tpaNphiesID,
            insurerName: checkStatusData.tpaNphiesNameEn,
            nphiesPayerlicense: checkStatusData.nphiesPayerlicense
        })
        this.replaceCheckStatusRequest('provider', {
            providerId: checkStatusData.nphiesProvID,
            providerName: checkStatusData.provName,
            nphiesProviderlicense: checkStatusData.nphiesProviderlicense,
            nphiesProviderTypeCode: checkStatusData.nphiesProviderTypeCode,
            nphiesProviderTypeDisplay: checkStatusData.nphiesProviderTypeDisplay
        })
        this.replaceCheckStatusRequest('endPoint', checkStatusData.naphiesReplacedUrl)
        //-----------------Cancel Req Log -------------------
        return this.returnBackEndProperties(checkStatusData, 'CheckStatusRequest', this.checkStatusJson, 'http://sgh.sa.com')
    }
    replaceCheckStatusRequest(keyName, KeyVal) {
        //__________________GUID_Replace________________
        if (keyName == 'guidReplacement') {
            this.checkStatusJson['entry'][0].resource['id'] = KeyVal
            this.checkStatusJson['entry'][0].fullUrl = `urn:uuid:${KeyVal}`
            this.checkStatusJson['entry'][0].resource['focus'][0]['reference'] = `http://sgh.sa.com/Task/${KeyVal}`
            this.checkStatusJson['entry'][1].fullUrl = `http://sgh.sa.com/Task/${KeyVal}`
            this.checkStatusJson['entry'][1].resource['id'] = KeyVal
            this.checkStatusJson['entry'][1].resource['identifier'][0]['value'] = KeyVal
        }
        //_____________Check_Status_type_replace________
        if (keyName == 'CheckStatusType') {
            //  this.checkStatusJson['entry'][1].resource['focus']['type'] = KeyVal
            this.checkStatusJson['entry'][1].resource['focus']['identifier']['system'] = `http://sgh.sa.com/${KeyVal}`
        }
        //______  __nphise_Claim_ID_For_Check_Status____
        if (keyName == 'ClaimID') {
            this.checkStatusJson['entry'][1].resource['focus']['identifier']['value'] = KeyVal
        }

        //____________Task_three_parms_Replace__________
        if (keyName == 'TaskThreeParms') {
            if (KeyVal.nphiesPollTaskStatus) {
                this.checkStatusJson['entry'][1].resource['status'] = KeyVal.nphiesPollTaskStatus
            }

            if (KeyVal.nphiesPollRequestIntent) {
                this.checkStatusJson['entry'][1].resource['intent'] = KeyVal.nphiesPollRequestIntent
            }

            if (KeyVal.priority) {
                this.checkStatusJson['entry'][1].resource['priority'] = KeyVal.priority
            }
        }
        //____---__________Date_Replacment______________
        if (keyName == 'currentDate') {
            this.checkStatusJson['entry'][1].resource['authoredOn'] = KeyVal.start
            this.checkStatusJson['entry'][1].resource['lastModified'] = KeyVal.end
        }
        //_____________Insurer_replacment_______________
        if (keyName == 'Insurer') {
            //______________Bind_Insurer_Id________________
            this.checkStatusJson['entry'][3].resource['id'] = KeyVal.insurerID
            this.checkStatusJson['entry'][3].fullUrl = `http://sgh.sa.com/Organization/${KeyVal.insurerID}`
            this.checkStatusJson['entry'][1].resource['owner']['reference'] = `http://sgh.sa.com/Organization/${KeyVal.insurerID}`
            //_____________Bind_Insurer_Name_______________
            this.checkStatusJson['entry'][3].resource['name'] = KeyVal.insurerName
            //_____________Bind_Payer-license______________
            this.checkStatusJson['entry'][3].resource['identifier'][0]['value'] = KeyVal.nphiesPayerlicense
            this.checkStatusJson['entry'][0].resource['destination'][0]['endpoint'] = `http://nphies.sa/license/payer-license/${KeyVal.nphiesPayerlicense}`
            this.checkStatusJson['entry'][0].resource['destination'][0]['receiver']['identifier']['value'] = KeyVal.nphiesPayerlicense
        }
        //____________Provider_replacement______________
        if (keyName == 'provider') {
            //______________Bind_Provider_Id________________
            this.checkStatusJson['entry'][2].resource['id'] = KeyVal.providerId
            this.checkStatusJson['entry'][2].fullUrl = `http://sgh.sa.com/Organization/${KeyVal.providerId}`
            this.checkStatusJson['entry'][1].resource['requester']['reference'] = `http://sgh.sa.com/Organization/${KeyVal.providerId}`
            //_____________Bind_Provider_Name_______________
            this.checkStatusJson['entry'][2].resource['name'] = KeyVal.providerName
            //_____________Bind_Provider-license______________
            this.checkStatusJson['entry'][2].resource['identifier'][0]['value'] = KeyVal.nphiesProviderlicense
            this.checkStatusJson['entry'][0].resource['sender']['identifier']['value'] = KeyVal.nphiesProviderlicense
            //_____________Bind_Provider-Type______________
            this.checkStatusJson['entry'][2].resource['extension'][0]['valueCodeableConcept']['coding'][0]['code'] = KeyVal.nphiesProviderTypeCode
            this.checkStatusJson['entry'][2].resource['extension'][0]['valueCodeableConcept']['coding'][0]['display'] = KeyVal.nphiesProviderTypeDisplay
        }
        //__________________End_Point___________________
        if (keyName == "endPoint") {
            this.checkStatusJson['entry'][0].resource['source']['endpoint'] = KeyVal
        }

        //______________________________________________

    }
    //-----------------------Payment Request----------------------------
    replacePaymentRequest(keyName, KeyVal) {
        if (keyName == "messageHeaderId") {
            this.fhirJsonObj['entry'][0].resource['id'] = KeyVal
            this.fhirJsonObj['entry'][0].fullUrl = `urn:uuid:${KeyVal}`
        }

        if (keyName == "messageHeaderFocusId") {
            this.fhirJsonObj['entry'][1].fullUrl = `http://saudidentalclinic.com.sa/PaymentNotice/${KeyVal}`
            this.fhirJsonObj['entry'][1].resource['id'] = KeyVal
            this.fhirJsonObj['entry'][1].resource['identifier'][0]['value'] = KeyVal
            this.fhirJsonObj['entry'][0].resource['focus'][0]['reference'] = `http://saudidentalclinic.com.sa/PaymentNotice//${KeyVal}`
            this.fhirJsonObj['entry'][1].resource['payment']['identifier']['value'] = KeyVal;
        }

        if (keyName == "paymentDate") {
            this.fhirJsonObj['entry'][1].resource['paymentDate'] = KeyVal
            this.fhirJsonObj['entry'][1].resource['created'] = KeyVal
        }

        if (keyName == "sender") {
            let id = KeyVal.resource['id']
            let senderName = KeyVal.resource['name']
            this.fhirJsonObj['entry'][1].resource['provider']['reference'] = `http://saudidentalclinic.com.sa/Organization/${id}`
            this.fhirJsonObj['entry'][1].resource['provider']['payee'] = `http://saudidentalclinic.com.sa/Organization/${id}`
            this.fhirJsonObj['entry'][2].fullUrl = `http://saudidentalclinic.com.sa/Organization/${id}`
            this.fhirJsonObj['entry'][2].resource['id'] = id
            this.fhirJsonObj['entry'][2].resource['name'] = senderName;
        }

        // if (keyName == "resciever") {
        //     let id = KeyVal.resource['id']
        //     let rescieverName = KeyVal.resource['name']
        //     //  this.fhirJsonObj['entry'][1].resource['recipient']['reference'] = `Organization/${id}`
        //     this.fhirJsonObj['entry'][3].fullUrl = `http://pr-fhir.com.sa/Organization/${id}`
        //     this.fhirJsonObj['entry'][3].resource['id'] = id
        //     this.fhirJsonObj['entry'][3].resource['name'] = rescieverName;
        // }

        this.fhirJsonObj['entry'][1].resource['payment']['identifier']['system'] = "http://saudidentalclinic.com.sa/PaymentReconciliation"

    }
    //-----------------------------------------------------------------------------

    //______________VITAL_SIGN_METHOD_____________________________
    informationSequenceArr = []

    returnVitalSignJsonAfterBind(vitalSignList) {
        let count = 0
        let SupportingInfoTempArr = [];
        this.informationSequenceArr = []
        let eleOBJStructure = <any>{}
        let vitalSign
        //let vitalSignVal
        let opticalVitalVal
        vitalSignList.forEach((ele, index) => {
            //------if ele not null || undefined ------> return ele structure from "vitalSign.json"  && set its values
            if (ele.vitalSignVal) {
                vitalSign = ele.vitalSignVal.split('__THEN__')[0]
                opticalVitalVal = ele.vitalSignVal
            }


            count = count + 1
            eleOBJStructure = <any>{}
            eleOBJStructure = this.vitalSignJsonArr.find(e => e.category.coding[0].code == vitalSign)

            if (eleOBJStructure) {

                eleOBJStructure.sequence = count
                eleOBJStructure.category.coding[0].code = vitalSign


                if ((vitalSign != 'lab-test'
                    && vitalSign != 'chief-complaint'
                    && vitalSign != 'attachment'
                    && vitalSign != 'hospitalized'
                    && vitalSign != 'reason-for-visit'
                    && vitalSign != 'info'
                    && vitalSign != 'history-of-present-illness'
                    && vitalSign != 'patient-history'
                    && vitalSign != 'treatment-plan'
                    && vitalSign != 'physical-examination'
                )
                ) {

                    //    if (eleOBJStructure.valueQuantity) {
                    if (vitalSign != 'days-supply') {
                        let val = opticalVitalVal.split('__THEN__')[1]
                        if (val.length > 0 && eleOBJStructure.valueQuantity) {
                            eleOBJStructure.valueQuantity.value = val
                            delete eleOBJStructure.reason
                            this.informationSequenceArr.push(count)
                            SupportingInfoTempArr.push(eleOBJStructure)

                        }
                        else if (vitalSign == 'oxygen-saturation' || vitalSign == 'vital-sign-weight' ||
                            vitalSign == 'temperature' || vitalSign == 'pulse' || vitalSign == 'vital-sign-height' ||  vitalSign == 'respiratory-rate'
                        ) {
                            if (eleOBJStructure.valueQuantity) {
                                delete eleOBJStructure.valueQuantity
                            }
                            SupportingInfoTempArr.push(eleOBJStructure)
                        }
                    }

                    if (vitalSign == 'days-supply') {
                        let daysSupplyArr = []
                        daysSupplyArr = opticalVitalVal.split('__THEN__')
                        daysSupplyArr.splice(0, 1)
                        console.log('daysSupplyArr', daysSupplyArr)
                        if (daysSupplyArr.length > 0) {
                            let DaysSuplyObj = <MainStructureVital>{}
                            let categoryObj = <categoryInterFace>{}
                            let valueQuantityObj = <valueQuantityInterFace>{}
                            let codingInterfaceObj = <codingInterface>{}
                            daysSupplyArr.forEach((ele, index) => {
                                if (ele.length > 0) {
                                    count = count + 1
                                    DaysSuplyObj = <MainStructureVital>{}
                                    categoryObj = <categoryInterFace>{}
                                    valueQuantityObj = <valueQuantityInterFace>{}
                                    codingInterfaceObj = <codingInterface>{}
                                    DaysSuplyObj.sequence = count

                                    categoryObj.coding = []
                                    codingInterfaceObj.system = "http://nphies.sa/terminology/CodeSystem/claim-information-category"
                                    codingInterfaceObj.code = vitalSign
                                    categoryObj.coding.push(codingInterfaceObj)
                                    DaysSuplyObj.category = categoryObj

                                    valueQuantityObj.value = ele
                                    valueQuantityObj.system = "http://unitsofmeasure.org"
                                    valueQuantityObj.code = "d"
                                    DaysSuplyObj.valueQuantity = valueQuantityObj

                                    //  this.informationSequenceArr.push(count)
                                    SupportingInfoTempArr.push(DaysSuplyObj)
                                }

                            });
                        }
                        console.log('informationSequenceArr', this.informationSequenceArr)
                        console.log('SupportingInfoTempArr', SupportingInfoTempArr)
                    }
                    //}
                }


                if (vitalSign == 'chief-complaint' && opticalVitalVal.split('__THEN__').length >= 2) {
                    let chiefComplaintCode
                    let chiefComplaintText
                    let chiefComplaintDisplay
                    //----------------------------------------------//
                    let chiefComplaintObj  = <ChiefComplaint>{}
                    let chiefComplaintCodeObj  = <categoryInterFace>{}
                    let categoryObj = <categoryInterFace>{}
                    let chiefComplaintCodingInterfaceObj = <codingInterface>{}
                    let codingInterfaceObj = <codingInterface>{}
                    //----------------------------------------------//
                    categoryObj.coding = []
                    codingInterfaceObj.system = "http://nphies.sa/terminology/CodeSystem/claim-information-category"
                    codingInterfaceObj.code = 'chief-complaint'
                    categoryObj.coding.push(codingInterfaceObj)
                    chiefComplaintObj.sequence = count
                    chiefComplaintObj.category = categoryObj
                    //----------------------------------------------//

                    chiefComplaintCode = opticalVitalVal.split('__THEN__')[2]
                    chiefComplaintDisplay = opticalVitalVal.split('__THEN__')[3]
                    chiefComplaintText = opticalVitalVal.split('__THEN__')[1]
                    if ((chiefComplaintCode.length > 0)) { 
                        chiefComplaintCodingInterfaceObj.code = chiefComplaintCode
                        chiefComplaintCodingInterfaceObj.display = chiefComplaintDisplay
                        chiefComplaintCodingInterfaceObj.system = "http://snomed.info/sct"
                        chiefComplaintCodeObj.coding = []
                        chiefComplaintCodeObj.coding.push(chiefComplaintCodingInterfaceObj)
                    }
                    if ( (chiefComplaintText.length > 0)) {
                        chiefComplaintCodeObj.text = chiefComplaintText
                    }
                    //----------------------------------------------//
                    chiefComplaintObj.code= chiefComplaintCodeObj
                    //----------------------------------------------//

                        this.informationSequenceArr.push(count)
                        SupportingInfoTempArr.push(chiefComplaintObj)

                }

                if (vitalSign == 'attachment' && opticalVitalVal.split('__THEN__').length >= 6) {
                    let attchmentDate
                    let contentType
                    let title
                    let language
                    let size
                    let data
                    let attachmentObj = <Attachment>{}
                    let attachmentCategoryObj = <categoryInterFace>{}
                    let attachmentCategoryCodingInterfaceObj = <codingInterface>{}
                    let valueAttachmentObj = <ValueAttachment>{}
                    //====================//
                    attchmentDate = opticalVitalVal.split('__THEN__')[1]
                    contentType = opticalVitalVal.split('__THEN__')[2]
                    title = opticalVitalVal.split('__THEN__')[3]
                    language = opticalVitalVal.split('__THEN__')[4]
                    size = opticalVitalVal.split('__THEN__')[5]
                    data = opticalVitalVal.split('__THEN__')[6]
                    //====================//
                    if ((attchmentDate.length > 0) && (contentType.length > 0) &&  (title.length > 0) && (language.length > 0) && (size.length > 0) && (data.length > 0)) {

                        attachmentCategoryCodingInterfaceObj.code=  "attachment"
                        attachmentCategoryCodingInterfaceObj.system ="http://nphies.sa/terminology/CodeSystem/claim-information-category"
                        attachmentCategoryObj.coding = []
                        attachmentCategoryObj.coding.push(attachmentCategoryCodingInterfaceObj)

                        valueAttachmentObj.contentType= contentType
                        valueAttachmentObj.language = language
                        valueAttachmentObj.size = size
                        valueAttachmentObj.title=title
                        valueAttachmentObj.data= data
                        valueAttachmentObj.creation= attchmentDate

                        attachmentObj.sequence=count;
                        attachmentObj.category=attachmentCategoryObj;
                        attachmentObj.timingDate =attchmentDate;
                        attachmentObj.valueAttachment =valueAttachmentObj;
                        

                        this.informationSequenceArr.push(count)
                        SupportingInfoTempArr.push(attachmentObj)
                    }


                }

                if (vitalSign == 'hospitalized' && opticalVitalVal.split('__THEN__').length >= 2) {
                    let start
                    let end
                    start = opticalVitalVal.split('__THEN__')[1]
                    end = opticalVitalVal.split('__THEN__')[2]
                    if ((start.length > 0) && (end.length > 0)) {
                        eleOBJStructure['timingPeriod']['start'] = start
                        eleOBJStructure['timingPeriod']['end'] = end
                        this.informationSequenceArr.push(count)
                        SupportingInfoTempArr.push(eleOBJStructure)
                    }
                }

                if ((vitalSign == 'reason-for-visit' || vitalSign == 'investigation-result' || vitalSign == 'morphology' || vitalSign == 'onset') && opticalVitalVal.split('__THEN__').length >= 1) {
                    let visitReason
                    let display
                    let timingDate
                    visitReason = opticalVitalVal.split('__THEN__')[1]
                    display = opticalVitalVal.split('__THEN__')[2]
                    timingDate = opticalVitalVal.split('__THEN__')[3]

                    if ((visitReason.length > 0)) {
                        eleOBJStructure['code']['coding'][0]['code'] = visitReason
                        eleOBJStructure['code']['coding'][0]['display'] = display ? display : visitReason

                        if (vitalSign == 'onset') {
                            delete eleOBJStructure['code']['coding'][0]['display']
                            eleOBJStructure['code']['text'] = display ? display : visitReason
                            eleOBJStructure['timingDate'] = timingDate
                        }
                        this.informationSequenceArr.push(count)
                        SupportingInfoTempArr.push(eleOBJStructure)
                    }

                }

                if (vitalSign == 'lab-test' && opticalVitalVal.split('__THEN__').length >= 3) {
                    let labTestObj = <MainStructureVital>{}
                    let categoryObj = <categoryInterFace>{}
                    let categoryCodingInterfaceObj = <codingInterface>{}
                    let labTestCodeObj  =<categoryInterFace>{}
                    let labTesetCode_CodingProp = <codingInterface>{}
                    let valueQuantityObj = <valueQuantityInterFace>{}
                    let labCode
                    let labName
                    let labUnite
                    let labResultValue
                      //===========================================//
                    labCode = opticalVitalVal.split('__THEN__')[1]
                    labName = opticalVitalVal.split('__THEN__')[2]
                    labUnite = opticalVitalVal.split('__THEN__')[3]
                    labResultValue  = opticalVitalVal.split('__THEN__')[4]
                    if ((labCode.length > 0) && (labName.length > 0) && (labUnite.length > 0)  && (labResultValue.length > 0)) {
                        //===========================================//
                        categoryCodingInterfaceObj.code ="lab-test" 
                        categoryCodingInterfaceObj.system = "http://nphies.sa/terminology/CodeSystem/claim-information-category"
                        categoryObj.coding = []
                        categoryObj.coding.push(categoryCodingInterfaceObj)
                        //---------------------
                        labTesetCode_CodingProp.code=labCode
                        labTesetCode_CodingProp.display=labName
                        labTesetCode_CodingProp.system="http://loinc.org"
                        labTestCodeObj.coding = []
                        labTestCodeObj.coding.push(labTesetCode_CodingProp)
                        labTestCodeObj.text = labName
                        //---------------------
                        valueQuantityObj.code = labUnite
                        valueQuantityObj.system = "http://unitsofmeasure.org"
                        valueQuantityObj.value = labResultValue
                        //--------------------
                        labTestObj.sequence = count
                        labTestObj.category = categoryObj
                        labTestObj.code =  labTestCodeObj
                        labTestObj.valueQuantity= valueQuantityObj
                    
                        // eleOBJStructure['code']['coding'][0]['code'] = labCode
                        // eleOBJStructure['code']['text'] = labName
                        // eleOBJStructure['valueQuantity']['code'] = labUnite
                        // eleOBJStructure['valueQuantity']['code'] = labUnite
                        this.informationSequenceArr.push(count)
                        SupportingInfoTempArr.push(labTestObj)
                    }

                }

                if ((vitalSign == 'info' || vitalSign == 'history-of-present-illness' || vitalSign == 'patient-history' || vitalSign == 'treatment-plan' || vitalSign == 'physical-examination') && opticalVitalVal.split('__THEN__').length > 0) {
                    let text
                    text = opticalVitalVal.split('__THEN__')[1]
                    if ((text.length > 0)) {
                        eleOBJStructure['valueString'] = text
                        this.informationSequenceArr.push(count)
                        SupportingInfoTempArr.push(eleOBJStructure)
                    }

                }

            }


        })

        console.log('informationSequenceArrFROM_METHOD', this.informationSequenceArr)
        console.log('SupportingInfoTempArr_', SupportingInfoTempArr)
        return SupportingInfoTempArr
    }


    prepareAndReturnCoverageClassListToBind(coverageClassList) {
        let ClassList = [];
        /// Bind Coverage Data List  /////
        if (coverageClassList && coverageClassList.length > 0) {
            coverageClassList.forEach(ele => {
                let _coverageClassObj = <coverageClassObj>{}
                let codingInterfaceobj = <codingInterface>{}
                let coverageTypeObj = <coverageType>{}
                coverageTypeObj.coding = []

                codingInterfaceobj.code = ele.coverageClassType.replace(/_/g, "");
                codingInterfaceobj.system = "http://terminology.hl7.org/CodeSystem/coverage-class"

                coverageTypeObj.coding.push(codingInterfaceobj)

                _coverageClassObj.type = coverageTypeObj
                _coverageClassObj.value = ele.coverageClassvalue
                if (ele.coverageClassName) {
                    _coverageClassObj.name = ele.coverageClassName
                }

                ClassList.push(_coverageClassObj)
            });

        }
        return ClassList;
    }

    //____________________________________________________________________________
    getFhirJsonObj() {
        console.log(this.fhirJsonObj)
        return this.fhirJsonObj
    }
    getFhirJsonTxt(resourceTypeUrl?: string, url?: string, jsonObj?: any) {
        var jsonString = JSON.stringify(jsonObj)
        if (resourceTypeUrl) {
            while ((jsonString.indexOf(resourceTypeUrl)) > 0) {
                jsonString = jsonString.replace(resourceTypeUrl, url); //convert to JSON string
            }
        }
        return (jsonString)
    }
    validate(json: any, parentPath: string = ''): string[] {
        let errors: string[] = [];

        for (let key in json) {
            if (json.hasOwnProperty(key)) {
                const value = json[key];
                const currentPath = parentPath ? `${parentPath}.${key}` : key;

                if (value === undefined || value === null || value === 'null' || value === '' || (Array.isArray(value) && value.length === 0)) {
                    errors.push(`entry. ${currentPath}`);
                } else if (typeof value === 'object' && value !== null) {
                    errors = errors.concat(this.validate(value, currentPath));
                }
            }
        }

        return errors;
    }


    getJsonValueByPath(path: any): any {
        let pathParts = path.split('.');
        pathParts[1] = +pathParts[1]
        let value = this.fhirPriAuthorizationValidationMsg;
        console.log('pathParts _--->', path)

        for (let part of pathParts) {
            part = +part ? +part : part;
            if (value[part] !== undefined) {
                console.log('value = ', value)
                console.log('value[part] = ', value[part])
                value = value[part];
            } else {
                return undefined;
            }
        }

        return value;
    }
}
